import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          General: "General",
          Dashboards: "Dashboards",
          Default: "Default",
          Project: "Project",
          Ecommerce: "Ecommerce",
          Education: "Education",
          Widgets: "Widgets",
          Chart: "Chart",
          Applications: "Applications",
          "Project List": "Project List",
          "Create New": "Create New",
          "File Manager": "File Manager",
          "Add Product": "Add Product",
          Product: "Product",
          "Product Page": "Product Page",
          "Product List": "Product List",
          "Payment Details": "Payment Details",
          "Order History": "Order History",
          Invoice: "Invoice",
          "Invoice-1": "Invoice-1",
          "Invoice-2": "Invoice-2",
          "Invoice-3": "Invoice-3",
          "Invoice-4": "Invoice-4",
          "Invoice-5": "Invoice-5",
          "Invoice-6": "Invoice-6",
          Cart: "Cart",
          Wishlist: "Wishlist",
          Checkout: "Checkout",
          Pricing: "Pricing",
          Chat: "Chat",
          Users: "Users",
          "Letter Box": "Letter Box",
          "Private Chat": "Private Chat",
          "Group Chat": "Group Chat",
          "User Profile": "User Profile",
          "User Edit": "User Edit",
          "User Cards": "User Cards",
          Bookmarks: "Bookmarks",
          Contacts: "Contacts",
          Task: "Task",
          Calendar: "Calendar",
          "Social App": "Social App",
          Todo: "Todo",
          "Search Result": "Search Result",
          "Form Validation": "Form Validation",
          "Base Inputs": "Base Inputs",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Input Groups",
          "Input Mask": "Input Mask",
          "Mega Option": "Mega Option",
          Datepicker: "Datepicker",
          Touchspin: "Touchspin",
          Switch: "Switch",
          Forms: "Forms",
          "Form Controls": "Form Controls",
          "Forms & Table": "Forms & Table",
          Typeahead: "Typeahead",
          Clipboard: "Clipboard",
          "Form Widget": "Form Widget",
          "Form Wizard 1": "Form Wizard 1",
          "Form Wizard 2": "Form Wizard 2",
          "Two Factor": "Two Factor",
          "Form Layout": "Form Layout",
          Table: "Table",
          "Reactstrap Tables": "Reactstrap Tables",
          "Basic Tables": "Basic Tables",
          "Table Components": "Table Components",
          "Data Tables": "Data Tables",
          "Basic Init": "Basic Init",
          "Advance Init": "Advance Init",
          API: "API",
          "Data Source": "Data Source",
          Components: "Components",
          Typography: "Typography",
          Avatars: "Avatars",
          "Helper Classes": "Helper Classes",
          Grid: "Grid",
          "Tag & Pills": "Tag & Pills",
          Progress: "Progress",
          Modal: "Modal",
          Alert: "Alert",
          Popover: "Popover",
          Tooltip: "Tooltip",
          Dropdown: "Dropdown",
          Accordion: "Accordion",
          Tabs: "Tabs",
          Lists: "Lists",
          "Bonus-Ui": "Bonus-Ui",
          Scrollable: "Scrollable",
          "Tree View": "Tree View",
          Toasts: "Toasts",
          Rating: "Rating",
          Dropzone: "Dropzone",
          Tour: "Tour",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carousel",
          Ribbons: "Ribbons",
          Pagination: "Pagination",
          Breadcrumb: "Breadcrumb",
          "Range Slider": "Range Slider",
          "Image Cropper": "Image Cropper",
          "Basic Card": "Basic Card",
          "Creative Card": "Creative Card",
          Timeline: "Timeline",
          Icons: "Icons",
          "Flag Icon": "Flag Icon",
          "Fontawesome Icon": "Fontawesome Icon",
          "Ico Icon": "Ico Icon",
          "Themify Icon": "Themify Icon",
          "Feather Icon": "Feather Icon",
          "Weather Icon": "Weather Icon",
          Buttons: "Buttons",
          "Default Style": "Default Style",
          "Flat Style": "Flat Style",
          "Edge Style": "Edge Style",
          "Raised Style": "Raised Style",
          "Button Group": "Button Group",
          Charts: "Charts",
          "Apex Chart": "Apex Chart",
          "Google Chart": "Google Chart",
          "Chart JS Chart": "Chart JS Chart",
          Pages: "Pages",
          "Sample Page": "Sample Page",
          Others: "Others",
          "Error Pages": "Error Pages",
          "Error 400": "Error 400",
          "Error 401": "Error 401",
          "Error 403": "Error 403",
          "Error 404": "Error 404",
          "Error 500": "Error 500",
          "Error 503": "Error 503",
          "Login Simple": "Login Simple",
          "Login with Bg Image": "Login with bg Image",
          "Login With Image Two": "Login With Image Two",
          "Login With Validation": "Login With Validation",
          "Login With Tooltip": "Login With Tooltip",
          "Login With Sweetalert": "Login With Sweetalert",
          "Register Simple": "Register Simple",
          "Register With Bg Image": "Register With Bg Image",
          "Register With Bg Two": "Register With Bg Two",
          "Register Wizard": "Register Wizard",
          "Unlock User": "Unlock User",
          "Forget Password": "Forget Password",
          "Reset Password": "Reset Password",
          Maintenance: "Maintenance",
          "Coming Simple": "Coming Simple",
          "Coming With Bg Video": "Coming With Bg Video",
          "Coming With Bg Image": "Coming With Bg Image",
          Miscellaneous: "Miscellaneous",
          Gallery: "Gallery",
          "Gallery Grids": "Gallery Grids",
          "Gallery Grid Desc": "Gallery Grid Desc",
          "Masonry Gallery": "Masonry Gallery",
          "Masonry With Desc": "Masonry With Desc",
          "Hover Effect": "Hover Effect",
          Blog: "Blog",
          "Blog Details": "Blog Details",
          "Blog Single": "Blog Single",
          "Add Post": "Add Post",
          FAQ: "FAQ",
          "Job Search": "Job Search",
          "Cards View": "Cards View",
          "List View": "List View",
          "Job Detail": "Job Detail",
          Apply: "Apply",
          Learning: "Learning",
          "Learning List": "Learning List",
          "Detailed Course": "Detailed Course",
          Map: "Map",
          "Google Map": "Google Map",
          "Leaflet Map": "Leaflet Map",
          Editor: "Editor",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          "ACE Editor": "ACE Editor",
          Knowledgebase: "Knowledgebase",
          SupportTicket: "SupportTicket",
          Authentication: "Authentication",
          "Login With Bg Image": "Login With Bg Image",
          "Coming Soon": "Coming Soon",
          Pinned: "Pinned",
          "Master Data": "Master Data",
          Organizations: "Organizations",
          Dashboard: "Dashboard",
          OrganizationName: "Organization Name",
          OrganizationNamePlaceholder: "Organization name ",
          OrganizationMobile: "Mobile Number",
          OrganizationMobilePlaceholder: "Enter Mobile Number",
          OrganizationEmail: "Email",
          OrganizationEmailPlaceholder: "Enter Email Address",
          OrganizationAddress: "Address",
          OrganizationAddressPlaceholder: "Enter Address",
          OrganizationCountry: "Country",
          OrganizationCountryPlaceholder: "Select Country",
          OrganizationCity: "City",
          OrganizationCityPlaceholder: "Select City",
          OrganizationIndustry: "Industry",
          OrganizationIndustryPlaceholder: "Select Industry",
          Authority: "Authority",
          AuthorityPlaceholder: "Select Authority",
          OrganizationLogo: "Organization Logo",
          OrganizationWebsite: "Organization Website",
          OrganizationWebsitePlaceholder: "Enter Organization Website",
          WhiteLabel: "White Label",
          OrganizationContactPerson: "Contact Person",
          OrganizationContactPersonPlaceholder: "Enter Contact Person",
          OrganizationSubscriptionPlan: "Subscription Plan",
          OrganizationSubscriptionPlanPlaceholder: "Select Subscription Plan",
          ExpireyDate: "Expiry Date",
          PageLimit: "Page Limit",
          PageLimitPlaceholder: "Select Page Limit",
          DateFormat: "Date Format",
          DateFormatPlaceholder: "Select Date Format",
          Distributor: "Distributor",
          DistributorPlaceholder: "Select Distributor",
          Franchises: "Franchises",
          FranchisesPlaceholder: "Select Franchises",
          EmployeeAppAndroidKey: "Employee App Android Key",
          EmployeeAppAndroidkeyplaceholder: "Enter Employee App Android Key",
          EmployeeAppAndroidURL: "Employee App Android URL",
          EmployeeAppAndroidURLplaceholder: "Enter Employee App Android URL",
          EmployeeAppIOSKey: "Employee App IOS Key",
          EmployeeAppIOSkeyplaceholder: "Enter Employee App IOS Key",
          EmployeeAppIOSURL: "Employee App IOS URL",
          EmployeeAppIOURLplaceholder: "Enter Employee App IOS URL",
          OrganizationBrowserGoogleKey: "Browser Google Key",
          OrganizationBrowserGoogleKeyPlaceholder: "Enter Browser Google Key",
          OrganizationTimezone: "Timezone",
          OrganizationTimezonePlaceholder: "Select Timezone",
          OrganizationCurrency: "Currency",
          OrganizationCurrencyPlaceholder: "Select Currency",
          Language: "Language",
          LanguagePlaceholder: "Select Language",
          OrganizationDetails: "Organization Details",
          OrganizationAdminDetails: "Organization Admin Details",
          SubscriptionDetails: "Subscription Details",
          AppsandAPISettings: "Apps and API Settings",
          UpdateOrganization: "Update ",
          AddOrganization: "Add Organization",
          Cancel: "Cancel",
          ViewOrganization: "View Organization",
          AccountType: "Account Type",
          Entities: "Entities",
          Actions: "Actions",
          Status: "Status",
          SearchAny: "Search Anything...",
          AreYouSureYouWantToBlock: "Are you sure you want to Block",
          AreYouSureYouWantToUnblock: "Are you sure you want to Unblock",
          AreYouSureYouWantToDelete: "Are you sure you want to Delete",
          Confirm: "Confirm",
          EditOrganization: "Edit Organization",
          ResetPassword: "Reset Password",
          organizationAdmin: "Organization Admin",
          phonenumber: "Phone Number",
          email: "Email",
          EditOrganizationAdmin: "Edit",
          BirthDate: "Date of birth",
          Gender: "Gender",
          ViewOrganizationAdmin: "View Organization Admin",
          "Are you sure?": "Are you sure?",
          "Do you want to block this user?": "Do you want to block this user?",
          FirstName: "First Name",
          LastName: "Last Name",
          FirstNamePlaceholder: "Enter First Name",
          LastNamePlaceholder: "Enter Last Name",
          UserImage: "User Image",
          EditOrgAdmin: "Edit Organization Admin",
          ActivityLog: "Activity Log",
          ActivitylogHistory: "Activity Log History",
          SectionUpdate: "Section Update",
          NoActivityhistoryMessage: "No activity history found for this user.",
          password: "Password",
          EnterPassword: "Enter Password",
          ConfirmPassword: "Confirm Password",
          EnterConfirmPassword: "Enter Confirm Password",
          SignIn: "Sign In",
          Filters: "Filters",
          Search: "Search",
          Date: "Date",
          Action: "Action",
          Export: "Export",
          AccessRights: "Access Rights",
          pdf: "Export as PDF",
          Excel: "Export as EXCEL",
          selectName: "Select Name",
          selectGender: "Select Gender",
          selectStatus: "Select Status",
          MasterSetting: "Master Settings",
          Holidays: "Holidays",
          AddHolidays: "Add Holidays",
          HolidayNamePlaceholder: "Holiday name",
          HolidayName: "Holiday Name",
          Type: "Type",
          SelectType: "Select Type",
          Country: "Country ",
          SelectCountry: "Select Country",
          IsthisaTentativeDate: "Is this a Tentative Date",
          National: "National",
          Religious: "Religious",
          Cultural: "Cultural",
          Public: "Public",
          Countries: "Countries",
          Years: "Years",
          SearchByHolidayName: "Search by Type Name...",
          Save: "Save",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          "Sl.No": "Sl.No",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Edit: "Edit",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Delete: "Delete",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
          TaxName: "Tax Name",
          TaxCode: "Tax Code",
          CalculationType: "Calculation Type",
          EffectiveFrom: "Effective From",
          EffectiveTo: "Effective To",
          FixedAmount: "Fixed Amount",
          PercentageRate: "Percentage Rate",
          AddSlab: "Add Slab",
          SlabName: "Slab Name",
          SlabDescription: "Slab Description",
          AddRange: "Add Range",
          DeleteSlab: "Delete Slab",
          SaveSlab: "Save Slab",
          RangeFrom: "Range From",
          RangeTo: "Range To",
          DeleteRange: "Delete Range",
          EditSlab: "Edit Slab",
          Leaves: "Leaves",
          AddLeaves: "Add Leaves",
          LeaveNamePlaceholder: "Leave name",
          LeaveName: "Leave Name",
          SearchByLeaveName: "Search by Type Name...",
          ImportLeaves: "Import Leaves",
          ImportLeaveInstructions: "Import Leave Instructions",
          RequiredLeaveColumns:
            "Ensure the file contains required columns: {{columns}}",
          ImportLeaveTypeInstructions: "Import Leave Type Instructions",
          LeaveType: "Leave Type",
          AddLeaveType: "Add Leave Type",
          EditLeaveType: "Edit Leave Type",
          ImportLeaveType: "Import Leave Type",
          LeaveTypeInstructions: "Leave Type Instructions",
          OrganizationReport: "Organization Report",
          UserTrends: "User Trends",
          OrganizationTrends: "Organization Trends",
          Trends: "Trends",
          SMSGateway: "SMS Gateway",
          PaymentGateway: "Payment Gateway",
          GatewayName: "Gateway Name",
          GatewayURL: "Gateway URL",
          SMSreqFormat: "Request Format",
          Sales: "Sales",
          ProviderName: "Provider Name",
          APIURL: "API URL",
          GatewayType: "Gateway Type",
          RequestFormat: " Request Format",
          AddSalesUser: "Add Sales User",
          EnterFullName: "Enter Full Name",
          EnterEmail: "Enter Email",
          DateOfBirth: "Date Of Birth",
          SelectDOB: "Select DOB",
          SelectNationality: "Select Nationality",
          CountryCode: "Country Code",
          SelectCountryCode: "Select Country Code",
          MobileNumber: "Mobile Number",
          EnterMobileNumber: "Enter Mobile Number",
          SelectGender: "Select Gender",
          SelectLanguage: "Select Language",
          SetCustomPassword: "Set Custom Password",
          AutoGenerate: "Auto Generate",
          InvitationMail: "Invitation Mail",
          AutoGeneratedPassword: "Auto Generated Password",
          EnterCustomPassword: "Enter Custom Password",
          DragDropOrBrowse: "Drag Drop Or Browse",
          EnterFirstName: "Enter First Name",
          EnterLastName: "Enter Last Name",
          AddDeveloperUser: "Add Developer User",
          SandboxURLs: "Sandbox URLs",
          PaymentURL: "Payment URL",
          StatusURL: "Status URL",
          RefundURL: "Refund URL",
          RechargeURL: "Recharge URL",
          LiveURLs: "Live URLs",
          "Add Add-On": "Add Add-On",
          "Add-On": "Add-On",
          PlanName: "Plan Name",
          EnterPlanType: "Enter Plan Name",
          MonthlyPrice: "Monthly Price",
          EnterMonthlyPrice: "Enter Monthly Price",
          YearlyPrice: "Yearly Price",
          EnterYearlyPrice: "Enter Yearly Price",
          Benefits: "Benefits",
          EnterBenefitDescription: "Enter Benefit Description",
          AddBenefit: "Add Benefit",
          "Plan type is required": "Plan type is required",
          "Monthly price must be positive":
            "Monthly price must be a positive number",
          "Monthly price is required": "Monthly price is required",
          "Yearly price must be positive":
            "Yearly price must be a positive number",
          "Yearly price is required": "Yearly price is required",
          "Benefit description is required": "Benefit description is required",
          "At least one benefit is required":
            "At least one benefit is required",
          InviteSignup: "Invite Signup",
          SendInvite: "Send Invite",
          InvitationLink: "Invitation Link",
          AddSupportUser: "Add Support User",

          "Do you want to delete {{plan.type}}?":
            "Do you want to delete {{plan.type}}?",

          Deactivate: "Deactivate",
          Activate: "Activate",
          "Toggle status functionality is disabled as data is static.":
            "Toggle status functionality is disabled as data is static.",
          "Delete functionality is disabled as data is static.":
            "Delete functionality is disabled as data is static.",
          "Search by Plan Name": "Search by Plan Name",
          "There are no records to display": "There are no records to display",
          Active: "Active",
          Inactive: "Inactive",
          Activation: "Activation",
          "/yr": "/yr",
          "/mo": "/mo",
          "Edit Add-On": "Edit Add-On",

          "Plan Name": "Plan Name",
          "Subscription Type": "Subscription Type",
          "Select Subscription Type": "Select Subscription Type",
          "One Time": "One Time",
          Periodically: "Periodically",
          "Activation Price": "Activation Price",
          "Enter Activation Price": "Enter Activation Price",
          "Monthly Price": "Monthly Price",
          "Enter Monthly Price": "Enter Monthly Price",
          "Yearly Price": "Yearly Price",
          "Enter Yearly Price": "Enter Yearly Price",
          "Enter Benefit Description": "Enter Benefit Description",
          "Add Benefit": "Add Benefit",

          "Save functionality is disabled as data is static.":
            "Save functionality is disabled as data is static.",
          "Subscription type is required": "Subscription type is required",
          signInToYourAccount: "Sign In to your account",
          enterEmailAndPassword: "Enter your email & password to login",
          emailAddress: "Email Address",
          emailPlaceholder: "Test@gmail.com",
          rememberPassword: "Remember Password",
          forgotPassword: "Forgot Password?",
          loginWithOtp: "Login with OTP",
          signIn: "Sign In",
          invalidCredentials: "Please Enter valid email or password...!",

          otpLogin: "OTP Login",
          enterYourEmail: "Enter Your Email",
          emailPlaceholderOtp: "example@domain.com",
          send: "Send",
          didNotReceiveOtp: "If you didn't receive an OTP? ",
          resend: "Resend",
          enterOtp: "Enter OTP",
          submit: "Submit",
          wantToLoginWithPassword: "Want to login with password?",
          loginWithPassword: "Login with Password",
          EditSalesUser: "Edit Sales User",
          EditDeveloperUser: "Edit Developer User",
          EditSupportUser: "Edit Support User",
          EditTaxType: "Edit Tax Type",
          SMTPConfiguration: "SMTP Configuration",
          DistributorDomain: "Domain Name",
          EnterDistributorDomain: "Enter Domain Name",
          DistributorName: "User Name",
          EnterDistributorName: "Enter User Name",
          SMTPEmail: "SMTP Email",
          EnterSMTPEmail: "Enter SMTP Email",
          SMTPPassword: "SMTP Password",
          EnterSMTPPassword: "Enter SMTP Password",
          SMTPDomain: "SMTP Domain",
          EnterSMTPDomain: "Enter SMTP Domain",
          SMTPPort: "SMTP Port",
          EnterSMTPPort: "Enter SMTP Port",
          SMTPProtocol: "SMTP Protocol",
          EnterSMTPProtocol: "Enter SMTP Protocol",
          FromAddress: "From Address",
          EnterFromAddress: "Enter From Address",
          Encryption: "Encryption",
          SSL: "SSL",
          TLS: "TLS",
          Submit: "Submit",
          Close: "Close",
          PrimaryColor: "Primary Color",
          SecondaryColor: "Secondary Color",
          TertiaryColor: "Tertiary Color",
          QuaternaryColor: "Quaternary Color",
          QuinaryColor: "Quinary Color",
          OrganizationBigLogo: "Organization Big Logo",
          OrganizationSmallLogo: "Organization Small Logo",
          OrganizationFaviconLogo: "Organization Favicon Logo",
          Branding: "Branding",
          View: "View",
          Block: "Block",
          CRMURL: "CRMURL",
          EnterCRMURL: "Enter CRM Url",
          LinkHubURL: "Link Hub URL",
          EnterLinkHubURL: "Enter Link Hub URL",
          PinterestURL: "Pinterest URL",
          EnterPinterestURL: "Enter Pinterest URL",
          LinkedInURL: "LinkedIn URL",
          EnterLinkedInURL: "Enter LinkedIn URL",
          FacebookURL: "Facebook URL",
          EnterFacebookURL: "Enter Facebook URL",
          InstagramURL: "Instagram URL",
          TwitterURL: "Twitter URL",
          EnterTwitterURL: "Enter Twitter URL",
          ERPURL: "ERP URL",
          ServiceURL: "ServiceURL",
          EnterServiceURL: "Enter Service URL",
          MasterAccess: "Master Access",
          ActivityLogsHistory: "Activity Logs History",
          AccessRightsHistory: "Access Rights History",
          CreateYourAccount: "Register Now",
          FirstNameRequired: "First name required",
          LastNameRequired: "Last name required",
          OrganizationNameRequired: "Organization name required",
          CountryRequired: "Country Required",
          CityRequired: "City Required",
          CountryCodeRequired: "Country Code Required",
          PhoneNumberInvalid: "Phone Number Invalid",
          PhoneNumberRequired: "Phone Number Required",
          EmailRequired: "Email Required",
          PasswordMinLength: "Password Min Length",
          PasswordRequired: "Password Required",
          ConfirmPasswordMatch: "Confirm Password Match",
          ConfirmPasswordRequired: "Confirm Password Required",
          "Already have an account?": "Already have an account?",
          RegistrationSuccessTitle: "successfully Registered  !",
          RegistrationSuccessText:
            "Please check your email to verify your account!",
          BillsPayment: "Bills & Payment",
          duedate: "Due Date",
          amount: "Amount",
          CancelInvoice: "Cancel Invoice",
          ViewInvoice: "View Invoice",
          DueDate: "Due Date",
          APIKeys: "API Keys",
          AddAPIKey: "Add API Key",
          Searchbyname: "Search by name",
          APIKey: "API Key",
          EnterAPIkeyname: "Enter API key name",
          AddItem:"Add Item",
          Saveasdraft:"Save as draft",
          UpdateInvoice:"Update Invoice",
          Communication:"Communication",
          Name:"Name",
          "User Name":"User Name",
          "User Role":"User Role",
          "Role":"Role",
          Receipt:"Reciept"
          
        },
      },
      cn: {
        translations: {
          General: "通用",
          Dashboards: "仪表板",
          Default: "默认",
          Project: "项目",
          Ecommerce: "电子商务",
          Education: "教育",
          Widgets: "小部件",
          Chart: "图表",
          Applications: "应用",
          "Project List": "项目列表",
          "Create New": "创建新项目",
          "File Manager": "文件管理器",
          "Add Product": "添加产品",
          Product: "产品",
          "Product Page": "产品页面",
          "Product List": "产品列表",
          "Payment Details": "支付详情",
          "Order History": "订单历史",
          Invoice: "发票",
          "Invoice-1": "发票-1",
          "Invoice-2": "发票-2",
          "Invoice-3": "发票-3",
          "Invoice-4": "发票-4",
          "Invoice-5": "发票-5",
          "Invoice-6": "发票-6",
          Cart: "购物车",
          Wishlist: "愿望清单",
          Checkout: "结账",
          Pricing: "定价",
          Chat: "聊天",
          Users: "用户",
          "Letter Box": "信箱",
          "Private Chat": "私人聊天",
          "Group Chat": "群聊",
          "User Profile": "用户资料",
          "User Edit": "用户编辑",
          "User Cards": "用户卡片",
          Bookmarks: "书签",
          Contacts: "联系人",
          Task: "任务",
          Calendar: "日历",
          "Social App": "社交应用",
          Todo: "待办事项",
          "Search Result": "搜索结果",
          "Form Validation": "表单验证",
          "Base Inputs": "基本输入",
          "Checkbox & Radio": "复选框和单选按钮",
          "Input Groups": "输入组",
          "Input Mask": "输入掩码",
          "Mega Option": "超级选项",
          Datepicker: "日期选择器",
          Touchspin: "触摸旋转",
          Switch: "开关",
          Forms: "表单",
          "Form Controls": "表单控件",
          "Forms & Table": "表单和表格",
          Typeahead: "自动补全",
          Clipboard: "剪贴板",
          "Form Widget": "表单小部件",
          "Form Wizard 1": "表单向导 1",
          "Form Wizard 2": "表单向导 2",
          "Two Factor": "双因素认证",
          "Form Layout": "表单布局",
          Table: "表格",
          "Reactstrap Tables": "Reactstrap 表格",
          "Basic Tables": "基础表格",
          "Table Components": "表格组件",
          "Data Tables": "数据表格",
          "Basic Init": "基本初始化",
          "Advance Init": "高级初始化",
          API: "API",
          "Data Source": "数据源",
          Components: "组件",
          Typography: "排版",
          Avatars: "头像",
          "Helper Classes": "辅助类",
          Grid: "网格",
          "Tag & Pills": "标签和胶囊",
          Progress: "进度条",
          Modal: "模态框",
          Alert: "警告",
          Popover: "弹出框",
          Tooltip: "工具提示",
          Dropdown: "下拉菜单",
          Accordion: "手风琴",
          Tabs: "选项卡",
          Lists: "列表",
          "Bonus-Ui": "额外界面",
          Scrollable: "可滚动",
          "Tree View": "树形视图",
          Toasts: "通知",
          Rating: "评分",
          Dropzone: "拖放区",
          Tour: "引导",
          SweetAlert2: "SweetAlert2",
          Carousel: "轮播",
          Ribbons: "缎带",
          Pagination: "分页",
          Breadcrumb: "面包屑",
          "Range Slider": "范围滑块",
          "Image Cropper": "图片裁剪器",
          "Basic Card": "基础卡片",
          "Creative Card": "创意卡片",
          Timeline: "时间轴",
          Icons: "图标",
          "Flag Icon": "国旗图标",
          "Fontawesome Icon": "Fontawesome 图标",
          "Ico Icon": "Ico 图标",
          "Themify Icon": "Themify 图标",
          "Feather Icon": "Feather 图标",
          "Weather Icon": "天气图标",
          Buttons: "按钮",
          "Default Style": "默认样式",
          "Flat Style": "平面样式",
          "Edge Style": "边缘样式",
          "Raised Style": "凸起样式",
          "Button Group": "按钮组",
          Charts: "图表",
          "Apex Chart": "Apex 图表",
          "Google Chart": "Google 图表",
          "Chart JS Chart": "Chart JS 图表",
          Pages: "页面",
          "Sample Page": "示例页面",
          Others: "其他",
          "Error Pages": "错误页面",
          "Error 400": "错误 400",
          "Error 401": "错误 401",
          "Error 403": "错误 403",
          "Error 404": "错误 404",
          "Error 500": "错误 500",
          "Error 503": "错误 503",
          "Login Simple": "简单登录",
          "Login with Bg Image": "带背景图片的登录",
          "Login With Image Two": "带图片二的登录",
          "Login With Validation": "带验证的登录",
          "Login With Tooltip": "带工具提示的登录",
          "Login With Sweetalert": "带 Sweetalert 的登录",
          "Register Simple": "简单注册",
          "Register With Bg Image": "带背景图片的注册",
          "Register With Bg Two": "带背景二的注册",
          "Register Wizard": "注册向导",
          "Unlock User": "解锁用户",
          "Forget Password": "忘记密码",
          "Reset Password": "重置密码",
          Maintenance: "维护",
          "Coming Simple": "简单即将推出",
          "Coming With Bg Video": "带背景视频的即将推出",
          "Coming With Bg Image": "带背景图片的即将推出",
          Miscellaneous: "杂项",
          Gallery: "图库",
          "Gallery Grids": "图库网格",
          "Gallery Grid Desc": "图库网格描述",
          "Masonry Gallery": "砖石图库",
          "Masonry With Desc": "带描述的砖石图库",
          "Hover Effect": "悬停效果",
          Blog: "博客",
          "Blog Details": "博客详情",
          "Blog Single": "单一博客",
          "Add Post": "添加帖子",
          FAQ: "常见问题",
          "Job Search": "职位搜索",
          "Cards View": "卡片视图",
          "List View": "列表视图",
          "Job Detail": "职位详情",
          Apply: "申请",
          Learning: "学习",
          "Learning List": "学习列表",
          "Detailed Course": "详细课程",
          Map: "地图",
          "Google Map": "Google 地图",
          "Leaflet Map": "Leaflet 地图",
          Editor: "编辑器",
          "CK Editor": "CK 编辑器",
          "MDE Editor": "MDE 编辑器",
          "ACE Editor": "ACE 编辑器",
          Knowledgebase: "知识库",
          SupportTicket: "支持工单",
          Authentication: "认证",
          "Login With Bg Image": "带背景图片的登录",
          "Coming Soon": "即将推出",
          Pinned: "置顶",
          "Master Data": "主数据",
          Organizations: "组织",
          Dashboard: "仪表板",
          OrganizationName: "组织名称",
          OrganizationNamePlaceholder: "组织名称",
          OrganizationMobile: "手机号码",
          OrganizationMobilePlaceholder: "输入手机号码",
          OrganizationEmail: "电子邮件",
          OrganizationEmailPlaceholder: "输入电子邮件地址",
          OrganizationAddress: "地址",
          OrganizationAddressPlaceholder: "输入地址",
          OrganizationCountry: "国家",
          OrganizationCountryPlaceholder: "选择国家",
          OrganizationCity: "城市",
          OrganizationCityPlaceholder: "选择城市",
          OrganizationIndustry: "行业",
          OrganizationIndustryPlaceholder: "选择行业",
          Authority: "权限",
          AuthorityPlaceholder: "选择权限",
          OrganizationLogo: "组织标志",
          OrganizationWebsite: "组织网站",
          OrganizationWebsitePlaceholder: "输入组织网站",
          WhiteLabel: "白标",
          OrganizationContactPerson: "联系人",
          OrganizationContactPersonPlaceholder: "输入联系人",
          OrganizationSubscriptionPlan: "订阅计划",
          OrganizationSubscriptionPlanPlaceholder: "选择订阅计划",
          ExpiryDate: "到期日期",
          PageLimit: "页面限制",
          PageLimitPlaceholder: "选择页面限制",
          DateFormat: "日期格式",
          DateFormatPlaceholder: "选择日期格式",
          Distributor: "分销商",
          DistributorPlaceholder: "选择分销商",
          Franchises: "加盟商",
          FranchisesPlaceholder: "选择加盟商",
          EmployeeAppAndroidKey: "员工应用安卓密钥",
          EmployeeAppAndroidkeyplaceholder: "输入员工应用安卓密钥",
          EmployeeAppAndroidURL: "员工应用安卓URL",
          EmployeeAppAndroidURLplaceholder: "输入员工应用安卓URL",
          EmployeeAppIOSKey: "员工应用iOS密钥",
          EmployeeAppIOSkeyplaceholder: "输入员工应用iOS密钥",
          EmployeeAppIOSURL: "员工应用iOS URL",
          EmployeeAppIOURLplaceholder: "输入员工应用iOS URL",
          OrganizationBrowserGoogleKey: "浏览器Google密钥",
          OrganizationBrowserGoogleKeyPlaceholder: "输入浏览器Google密钥",
          OrganizationTimezone: "时区",
          OrganizationTimezonePlaceholder: "选择时区",
          OrganizationCurrency: "货币",
          OrganizationCurrencyPlaceholder: "选择货币",
          Language: "语言",
          LanguagePlaceholder: "选择语言",
          OrganizationDetails: "组织详情",
          OrganizationAdminDetails: "组织管理员详情",
          SubscriptionDetails: "订阅详情",
          AppsandAPISettings: "应用和API设置",
          UpdateOrganization: "更新",
          AddOrganization: "添加组织",
          Cancel: "取消",
          ViewOrganization: "查看组织",
          AccountType: "账户类型",
          Entities: "实体",
          Actions: "操作",
          Status: "状态",
          SearchAny: "搜索任何内容...",
          AreYouSureYouWantToBlock: "您确定要阻止吗",
          AreYouSureYouWantToUnblock: "您确定要解除阻止吗",
          AreYouSureYouWantToDelete: "您确定要删除吗",
          Confirm: "确认",
          EditOrganization: "编辑组织",
          ResetPassword: "重置密码",
          organizationAdmin: "组织管理员",
          phonenumber: "电话号码",
          email: "电子邮件",
          EditOrganizationAdmin: "编辑",
          BirthDate: "出生日期",
          Gender: "性别",
          ViewOrganizationAdmin: "查看组织管理员",
          "Are you sure?": "您确定吗？",
          "Do you want to block this user?": "您想阻止此用户吗？",
          FirstName: "名字",
          LastName: "姓氏",
          FirstNamePlaceholder: "输入名字",
          LastNamePlaceholder: "输入姓氏",
          UserImage: "用户图像",
          EditOrgAdmin: "编辑组织管理员",
          ActivityLog: "活动日志",
          ActivitylogHistory: "活动日志历史",
          SectionUpdate: "部分更新",
          NoActivityhistoryMessage: "未找到此用户的活动历史。",
          password: "密码",
          EnterPassword: "输入密码",
          ConfirmPassword: "确认密码",
          EnterConfirmPassword: "输入确认密码",
          SignIn: "登录",
          Filters: "筛选",
          Search: "搜索",
          Date: "日期",
          Action: "操作",
          Export: "导出",
          AccessRights: "访问权限",
          pdf: "导出为PDF",
          Excel: "导出为Excel",
          selectName: "选择名称",
          selectGender: "选择性别",
          selectStatus: "选择状态",
          MasterSetting: "主设置",
          Holidays: "假期",
          AddHolidays: "添加假期",
          HolidayNamePlaceholder: "假期名称",
          HolidayName: "假期名称",
          Type: "类型",
          SelectType: "选择类型",
          Country: "国家",
          SelectCountry: "选择国家",
          IsthisaTentativeDate: "这是一个暂定日期吗",
          National: "国家",
          Religious: "宗教",
          Cultural: "文化",
          Public: "公共",
          Countries: "国家",
          Years: "年份",
          SearchByHolidayName: "按假期名称搜索...",
          Save: "保存",
          Settings: "设置",
          ImportHolidays: "导入假期",
          ImportHolidayInstructions: "导入假期说明",
          UseStandardExcelFormat: "使用标准Excel格式",
          RequiredHolidayColumns: "确保文件包含所需列：{{columns}}",
          MaxFileSize: "最大文件大小为 {{size}}。",
          SelectExcelFile: "选择Excel文件",
          DownloadTemplate: "下载模板",
          Import: "导入",
          DateFormatImport: "使用日期格式：{{format}}",
          Reports: "报告",
          UserActivity: "用户活动",
          IPManagement: "IP管理",
          WhiteList: "白名单",
          BlackList: "黑名单",
          nonList: "非列表",
          IPAddress: "IP地址",
          "Sl.No": "序号",
          LastActivity: "最后活动",
          DateTime: "日期和时间",
          Location: "位置",
          SearchIPAddress: "搜索IP地址...",
          NoIPDataFound: "未找到IP数据。",
          GeneralSettings: "常规设置",
          MasterSetings: "主设置",
          TaxTypes: "税种",
          AddTaxTypes: "添加税种",
          LastLoginReport: "最后登录报告",
          userName: "用户名",
          userRole: "用户角色",
          LoginFailures: "登录失败",
          UsersReport: "用户报告",
          Reason: "原因",
          Hits: "点击量",
          ViewAll: "查看全部",
          ErrorLog: "错误日志",
          firstOccuranceTime: "首次发生时间",
          secondOccuranceTime: "最后发生时间",
          url: "URL",
          ErrorView: "错误日志视图",
          MyProfile: "我的资料",
          ImportHolidayTypeInstructions: "导入假期类型说明",
          HolidayType: "假期类型",
          AddHolidayType: "添加假期类型",
          EditHolidayType: "编辑假期类型",
          TypeName: "类型名称",
          TypeNameRequired: "类型名称是必填项",
          Description: "描述",
          Edit: "编辑",
          Add: "添加",
          Update: "更新",
          DeleteConfirmation: "您确定要删除吗？",
          Delete: "删除",
          ImportHolidayType: "导入假期类型",
          HolidayTypeInstructions: "假期类型说明",
          TaxName: "税种名称",
          TaxCode: "税码",
          CalculationType: "计算类型",
          EffectiveFrom: "生效日期",
          EffectiveTo: "终止日期",
          FixedAmount: "固定金额",
          PercentageRate: "百分比税率",
          AddSlab: "添加税阶",
          SlabName: "税阶名称",
          SlabDescription: "税阶描述",
          AddRange: "添加范围",
          DeleteSlab: "删除税阶",
          SaveSlab: "保存税阶",
          RangeFrom: "范围起始",
          RangeTo: "范围终止",
          DeleteRange: "删除范围",
          EditSlab: "编辑税阶",
          Leaves: "请假",
          AddLeaves: "添加请假",
          LeaveNamePlaceholder: "请假名称",
          LeaveName: "请假名称",
          SearchByLeaveName: "按请假名称搜索...",
          ImportLeaves: "导入请假",
          ImportLeaveInstructions: "导入请假说明",
          RequiredLeaveColumns: "确保文件包含所需列：{{columns}}",
          ImportLeaveTypeInstructions: "导入请假类型说明",
          LeaveType: "请假类型",
          AddLeaveType: "添加请假类型",
          EditLeaveType: "编辑请假类型",
          ImportLeaveType: "导入请假类型",
          LeaveTypeInstructions: "请假类型说明",
          OrganizationReport: "组织报告",
          UserTrends: "用户趋势",
          OrganizationTrends: "组织趋势",
          Trends: "趋势",
          SMSGateway: "短信网关",
          PaymentGateway: "支付网关",
          GatewayName: "网关名称",
          GatewayURL: "网关URL",
          SMSreqFormat: "请求格式",
          Sales: "销售",
          ProviderName: "提供商名称",
          APIURL: "API URL",
          GatewayType: "网关类型",
          RequestFormat: "请求格式",
          AddSalesUser: "添加销售用户",
          EnterFullName: "输入全名",
          EnterEmail: "输入电子邮件",
          DateOfBirth: "出生日期",
          SelectDOB: "选择出生日期",
          SelectNationality: "选择国籍",
          CountryCode: "国家代码",
          SelectCountryCode: "选择国家代码",
          MobileNumber: "手机号码",
          EnterMobileNumber: "输入手机号码",
          SelectGender: "选择性别",
          SelectLanguage: "选择语言",
          SetCustomPassword: "设置自定义密码",
          AutoGenerate: "自动生成",
          InvitationMail: "邀请邮件",
          AutoGeneratedPassword: "自动生成的密码",
          EnterCustomPassword: "输入自定义密码",
          DragDropOrBrowse: "拖放或浏览",
          EnterFirstName: "输入名字",
          EnterLastName: "输入姓氏",
          AddDeveloperUser: "添加开发者用户",
          SandboxURLs: "沙盒URL",
          PaymentURL: "支付URL",
          StatusURL: "状态URL",
          RefundURL: "退款URL",
          RechargeURL: "充值URL",
          LiveURLs: "实时URL",
          "Add Add-On": "添加附加组件",
          "Add-On": "附加组件",
          PlanName: "计划名称",
          EnterPlanType: "输入计划名称",
          MonthlyPrice: "月度价格",
          EnterMonthlyPrice: "输入月度价格",
          YearlyPrice: "年度价格",
          EnterYearlyPrice: "输入年度价格",
          Benefits: "福利",
          EnterBenefitDescription: "输入福利描述",
          AddBenefit: "添加福利",
          "Plan type is required": "计划类型是必填项",
          "Monthly price must be positive": "月度价格必须为正数",
          "Monthly price is required": "月度价格是必填项",
          "Yearly price must be positive": "年度价格必须为正数",
          "Yearly price is required": "年度价格是必填项",
          "Benefit description is required": "福利描述是必填项",
          "At least one benefit is required": "至少需要一个福利",
          InviteSignup: "邀请注册",
          SendInvite: "发送邀请",
          InvitationLink: "邀请链接",
          AddSupportUser: "添加支持用户",
          "Do you want to delete {{plan.type}}?": "您想删除 {{plan.type}} 吗？",
          Deactivate: "停用",
          Activate: "激活",
          "Toggle status functionality is disabled as data is static.": "由于数据是静态的，切换状态功能已被禁用。",
          "Delete functionality is disabled as data is static.": "由于数据是静态的，删除功能已被禁用。",
          "Search by Plan Name": "按计划名称搜索",
          "There are no records to display": "没有记录可显示",
          Active: "活跃",
          Inactive: "不活跃",
          Activation: "激活",
          "/yr": "/年",
          "/mo": "/月",
          "Edit Add-On": "编辑附加组件",
          "Plan Name": "计划名称",
          "Subscription Type": "订阅类型",
          "Select Subscription Type": "选择订阅类型",
          "One Time": "一次性",
          Periodically: "定期",
          "Activation Price": "激活价格",
          "Enter Activation Price": "输入激活价格",
          "Monthly Price": "月度价格",
          "Enter Monthly Price": "输入月度价格",
          "Yearly Price": "年度价格",
          "Enter Yearly Price": "输入年度价格",
          "Enter Benefit Description": "输入福利描述",
          "Add Benefit": "添加福利",
          "Save functionality is disabled as data is static.": "由于数据是静态的，保存功能已被禁用。",
          "Subscription type is required": "订阅类型是必填项",
          signInToYourAccount: "登录您的账户",
          enterEmailAndPassword: "输入您的电子邮件和密码以登录",
          emailAddress: "电子邮件地址",
          emailPlaceholder: "Test@gmail.com",
          rememberPassword: "记住密码",
          forgotPassword: "忘记密码？",
          loginWithOtp: "使用OTP登录",
          signIn: "登录",
          invalidCredentials: "请输入有效的电子邮件或密码...！",
          otpLogin: "OTP登录",
          enterYourEmail: "输入您的电子邮件",
          emailPlaceholderOtp: "example@domain.com",
          send: "发送",
          didNotReceiveOtp: "如果您没有收到OTP？",
          resend: "重新发送",
          enterOtp: "输入OTP",
          submit: "提交",
          wantToLoginWithPassword: "想用密码登录？",
          loginWithPassword: "使用密码登录",
          EditSalesUser: "编辑销售用户",
          EditDeveloperUser: "编辑开发者用户",
          EditSupportUser: "编辑支持用户",
          EditTaxType: "编辑税种",
          SMTPConfiguration: "SMTP配置",
          DistributorDomain: "分销商域名",
          EnterDistributorDomain: "输入分销商域名",
          DistributorName: "用户名",
          EnterDistributorName: "输入用户名",
          SMTPEmail: "SMTP电子邮件",
          EnterSMTPEmail: "输入SMTP电子邮件",
          SMTPPassword: "SMTP密码",
          EnterSMTPPassword: "输入SMTP密码",
          SMTPDomain: "SMTP域名",
          EnterSMTPDomain: "输入SMTP域名",
          SMTPPort: "SMTP端口",
          EnterSMTPPort: "输入SMTP端口",
          SMTPProtocol: "SMTP协议",
          EnterSMTPProtocol: "输入SMTP协议",
          FromAddress: "发件人地址",
          EnterFromAddress: "输入发件人地址",
          Encryption: "加密",
          SSL: "SSL",
          TLS: "TLS",
          Submit: "提交",
          Close: "关闭",
          PrimaryColor: "主要颜色",
          SecondaryColor: "次要颜色",
          TertiaryColor: "第三颜色",
          QuaternaryColor: "第四颜色",
          QuinaryColor: "第五颜色",
          OrganizationBigLogo: "组织大标志",
          OrganizationSmallLogo: "组织小标志",
          OrganizationFaviconLogo: "组织图标标志",
          Branding: "品牌",
          View: "查看",
          Block: "阻止",
          CRMURL: "CRM URL",
          EnterCRMURL: "输入CRM URL",
          LinkHubURL: "Link Hub URL",
          EnterLinkHubURL: "输入Link Hub URL",
          PinterestURL: "Pinterest URL",
          EnterPinterestURL: "输入Pinterest URL",
          LinkedInURL: "LinkedIn URL",
          EnterLinkedInURL: "输入LinkedIn URL",
          FacebookURL: "Facebook URL",
          EnterFacebookURL: "输入Facebook URL",
          InstagramURL: "Instagram URL",
          TwitterURL: "Twitter URL",
          EnterTwitterURL: "输入Twitter URL",
          ERPURL: "ERP URL",
          ServiceURL: "服务URL",
          EnterServiceURL: "输入服务URL",
          MasterAccess: "主访问权限",
          ActivityLogsHistory: "活动日志历史",
          AccessRightsHistory: "访问权限历史",
          CreateYourAccount: "立即注册",
          FirstNameRequired: "名字必填",
          LastNameRequired: "姓氏必填",
          OrganizationNameRequired: "组织名称必填",
          CountryRequired: "国家必填",
          CityRequired: "城市必填",
          CountryCodeRequired: "国家代码必填",
          PhoneNumberInvalid: "电话号码无效",
          PhoneNumberRequired: "电话号码必填",
          EmailRequired: "电子邮件必填",
          PasswordMinLength: "密码最小长度",
          PasswordRequired: "密码必填",
          ConfirmPasswordMatch: "确认密码匹配",
          ConfirmPasswordRequired: "确认密码必填",
          "Already have an account?": "已有账户？",
          RegistrationSuccessTitle: "注册成功！",
          RegistrationSuccessText: "请检查您的电子邮件以验证您的账户！",
          BillsPayment: "账单和支付",
          duedate: "到期日期",
          amount: "金额",
          CancelInvoice: "取消发票",
          ViewInvoice: "查看发票",
          DueDate: "到期日期",
          APIKeys: "API密钥",
          AddAPIKey: "添加API密钥",
          Searchbyname: "按名称搜索",
          APIKey: "API密钥",
          EnterAPIkeyname: "输入API密钥名称",
          AddItem: "添加项目",
          Saveasdraft: "保存为草稿",
          UpdateInvoice: "更新发票",
          Communication:"通信",
          Name:"名称",
          "User Name":"用户名",
          "User Role": "用户角色",
          Role:"角色",
          Receipt:"收据"        
        },
      },
      ae: {
        translations: {
          General: "عامة",
          Dashboards: "لوحات القيادة",
          Default: "افتراضي",
          Project: "مشروع",
          Ecommerce: "التجارة الإلكترونية",
          Education: "التعليم",
          Widgets: "حاجيات",
          Chart: "رسم بياني",
          Applications: "تطبيقات",
          "Project List": "قائمة المشروع",
          "Create New": "إنشاء جديد",
          "File Manager": "مدير الملفات",
          "Add Product": "إضافة منتج",
          Product: "منتج",
          "Product Page": "صفحة المنتج",
          "Product List": "قائمة المنتج",
          "Payment Details": "تفاصيل الدفع",
          "Order History": "تاريخ الطلب",
          Invoice: "فاتورة",
          "Invoice-1": "فاتورة-1",
          "Invoice-2": "فاتورة-2",
          "Invoice-3": "فاتورة-3",
          "Invoice-4": "فاتورة-4",
          "Invoice-5": "فاتورة-5",
          "Invoice-6": "فاتورة-6",
          Cart: "عربة التسوق",
          Wishlist: "قائمة الرغبات",
          Checkout: "السداد",
          Pricing: "التسعير",
          Chat: "دردشة",
          Users: "المستخدمين",
          "Letter Box": "صندوق البريد",
          "Private Chat": "الدردشة الخاصة",
          "Group Chat": "الدردشة الجماعية",
          "User Profile": "ملف المستخدم",
          "User Edit": "تحرير المستخدم",
          "User Cards": "بطاقات المستخدم",
          Bookmarks: "الإشارات المرجعية",
          Contacts: "جهات الاتصال",
          Task: "المهمة",
          Calendar: "التقويم",
          "Social App": "تطبيق اجتماعي",
          Todo: "قائمة المهام",
          "Search Result": "نتائج البحث",
          "Form Validation": "التحقق من النموذج",
          "Base Inputs": "المدخلات الأساسية",
          "Checkbox & Radio": "خانات الاختيار والراديو",
          "Input Groups": "مجموعات المدخلات",
          "Input Mask": "قناع المدخلات",
          "Mega Option": "خيار ميجا",
          Datepicker: "منتقي التاريخ",
          Touchspin: "اللمس الدوار",
          Switch: "التبديل",
          Forms: "النماذج",
          "Form Controls": "عناصر التحكم في النموذج",
          "Forms & Table": "النماذج والجداول",
          Typeahead: "التنبؤ التلقائي",
          Clipboard: "الحافظة",
          "Form Widget": "عنصر واجهة النموذج",
          "Form Wizard 1": "معالج النموذج 1",
          "Form Wizard 2": "معالج النموذج 2",
          "Two Factor": "العاملين بعاملين",
          "Form Layout": "تخطيط النموذج",
          Table: "الجدول",
          "Reactstrap Tables": "جداول Reactstrap",
          "Basic Tables": "الجداول الأساسية",
          "Table Components": "مكونات الجدول",
          "Data Tables": "جداول البيانات",
          "Basic Init": "البدء الأساسي",
          "Advance Init": "البدء المتقدم",
          API: "واجهة برمجة التطبيقات",
          "Data Source": "مصدر البيانات",
          Components: "المكونات",
          Typography: "الأسلوب الطباعي",
          Avatars: "الصور الرمزية",
          "Helper Classes": "فصول المساعدة",
          Grid: "الشبكة",
          "Tag & Pills": "العلامة والأقراص",
          Progress: "التقدم",
          Modal: "نافذة منبثقة",
          Alert: "تنبيه",
          Popover: "البوب أوفر",
          Tooltip: "تلميح",
          "Ui-Kits": "مجموعات واجهة المستخدم",
          Dropdown: "القائمة المنسدلة",
          Accordion: "الأكورديون",
          Tabs: "علامات التبويب",
          Lists: "القوائم",
          "Bonus-Ui": "واجهة المكافآت",
          Scrollable: "قابل للتمرير",
          "Tree View": "عرض الشجرة",
          Toasts: "التنبيهات",
          Rating: "التقييم",
          Dropzone: "منطقة الإفلات",
          Tour: "جولة",
          SweetAlert2: "التنبيه الحلو 2",
          Carousel: "ساحة البوم البوم البوم",
          Ribbons: "الشرائط",
          Pagination: "ترقيم الصفحات",
          Breadcrumb: "فتات الخبز",
          "Range Slider": "شريط النطاق",
          "Image Cropper": "أداة القص للصور",
          "Basic Card": "بطاقة أساسية",
          "Creative Card": "بطاقة إبداعية",
          Timeline: "الجدول الزمني",
          Icons: "الأيقونات",
          "Flag Icon": "أيقونة العلم",
          "Fontawesome Icon": "أيقونة Fontawesome",
          "Ico Icon": "أيقونة Ico",
          "Themify Icon": "أيقونة Themify",
          "Feather Icon": "أيقونة Feather",
          "Weather Icon": "أيقونة الطقس",
          Buttons: "أزرار",
          "Default Style": "الأسلوب الافتراضي",
          "Flat Style": "الأسلوب المسطح",
          "Edge Style": "الأسلوب الحاد",
          "Raised Style": "الأسلوب المرتفع",
          "Button Group": "مجموعة الأزرار",
          Charts: "الرسوم البيانية",
          "Apex Chart": "رسم بياني Apex",
          "Google Chart": "رسم بياني Google",
          "Chart JS Chart": "رسم بياني Chart JS",
          Pages: "الصفحات",
          "Sample Page": "صفحة عينة",
          Others: "أخرى",
          "Error Pages": "صفحات الخطأ",
          "Error 400": "خطأ 400",
          "Error 401": "خطأ 401",
          "Error 403": "خطأ 403",
          "Error 404": "خطأ 404",
          "Error 500": "خطأ 500",
          "Error 503": "خطأ 503",
          "Login Simple": "تسجيل الدخول البسيط",
          "Login with Bg Image": "تسجيل الدخول مع صورة الخلفية",
          "Login With Image Two": "تسجيل الدخول مع صورتين",
          "Login With Validation": "تسجيل الدخول مع التحقق",
          "Login With Tooltip": "تسجيل الدخول مع تلميح",
          "Login With Sweetalert": "تسجيل الدخول مع تنبيه Sweetalert",
          "Register Simple": "التسجيل البسيط",
          "Register With Bg Image": "التسجيل مع صورة الخلفية",
          "Register With Bg Two": "التسجيل مع صورتين",
          "Register Wizard": "معالج التسجيل",
          "Unlock User": "فتح المستخدم",
          "Forget Password": "نسيت كلمة المرور",
          "Reset Password": "إعادة تعيين كلمة المرور",
          Maintenance: "الصيانة",
          "Coming Simple": "قريبًا بسيط",
          "Coming With Bg Video": "قريبًا مع فيديو الخلفية",
          "Coming With Bg Image": "قريبًا مع صورة الخلفية",
          Miscellaneous: "متنوع",
          Gallery: "المعرض",
          "Gallery Grids": "شبكات المعرض",
          "Gallery Grid Desc": "وصف الشبكة في المعرض",
          "Masonry Gallery": "معرض الطوب",
          "Masonry With Desc": "مع الوصف",
          "Hover Effect": "تأثير التحويم",
          Blog: "المدونة",
          "Blog Details": "تفاصيل المدونة",
          "Blog Single": "مدونة فردية",
          "Add Post": "إضافة منشور",
          FAQ: "الأسئلة الشائعة",
          "Job Search": "بحث عن وظيفة",
          "Cards View": "عرض البطاقات",
          "List View": "عرض القائمة",
          "Job Detail": "تفاصيل الوظيفة",
          Apply: "تقديم الطلب",
          Learning: "التعلم",
          "Learning List": "قائمة التعلم",
          "Detailed Course": "دورة مفصلة",
          Map: "الخريطة",
          "Google Map": "الخريطة من Google",
          "Leaflet Map": "الخريطة من Leaflet",
          Editor: "المحرر",
          "CK Editor": "محرر CK",
          "MDE Editor": "محرر MDE",
          "ACE Editor": "محرر ACE",
          Knowledgebase: "قاعدة المعرفة",
          "Support Ticket": "تذكرة الدعم",
          Authentication: "المصادقة",
          "Login With Bg Image": "تسجيل الدخول مع صورة خلفية",
          Pinned: "مثبت",
          "Coming Soon": "قريبًا",
          "Master Data": "البيانات الرئيسية",
          Organizations: "المنظمات",
          Dashboard: "لوحة التحكم",
          OrganizationName: "اسم المنظمة",
          OrganizationNamePlaceholder: "اسم المنظمة *",
          OrganizationMobile: "رقم الجوال",
          OrganizationMobilePlaceholder: "أدخل رقم الجوال",
          OrganizationEmail: "البريد الإلكتروني",
          OrganizationEmailPlaceholder: "أدخل البريد الإلكتروني",
          OrganizationAddress: "العنوان",
          OrganizationAddressPlaceholder: "أدخل العنوان",
          OrganizationCountry: "الدولة",
          OrganizationCountryPlaceholder: "اختر الدولة",
          OrganizationCity: "المدينة",
          OrganizationCityPlaceholder: "اختر المدينة",
          OrganizationIndustry: "الصناعة",
          OrganizationIndustryPlaceholder: "اختر الصناعة",
          Authority: "الجهة المسؤولة",
          AuthorityPlaceholder: "اختر الجهة المسؤولة",
          OrganizationLogo: "شعار المنظمة",
          OrganizationWebsite: "موقع المنظمة",
          OrganizationWebsitePlaceholder: "أدخل موقع المنظمة",
          WhiteLabel: "تسمية بيضاء",
          OrganizationContactPerson: "شخص الاتصال",
          OrganizationContactPersonPlaceholder: "أدخل اسم شخص الاتصال",
          OrganizationSubscriptionPlan: "خطة الاشتراك",
          OrganizationSubscriptionPlanPlaceholder: "اختر خطة الاشتراك",
          ExpireyDate: "تاريخ الانتهاء",
          PageLimit: "حد الصفحات",
          PageLimitPlaceholder: "اختر حد الصفحات",
          DateFormat: "تنسيق التاريخ",
          DateFormatPlaceholder: "اختر تنسيق التاريخ",
          Distributor: "الموزع",
          DistributorPlaceholder: "اختر الموزع",
          Franchises: "الامتيازات",
          FranchisesPlaceholder: "اختر الامتيازات",
          EmployeeAppAndroidKey: "مفتاح تطبيق الموظف - أندرويد",
          EmployeeAppAndroidkeyplaceholder: "أدخل مفتاح تطبيق الموظف - أندرويد",
          EmployeeAppAndroidURL: "رابط تطبيق الموظف - أندرويد",
          EmployeeAppAndroidURLplaceholder: "أدخل رابط تطبيق الموظف - أندرويد",
          EmployeeAppIOSKey: "مفتاح تطبيق الموظف - iOS",
          EmployeeAppIOSkeyplaceholder: "أدخل مفتاح تطبيق الموظف - iOS",
          EmployeeAppIOSURL: "رابط تطبيق الموظف - iOS",
          EmployeeAppIOURLplaceholder: "أدخل رابط تطبيق الموظف - iOS",
          OrganizationBrowserGoogleKey: "مفتاح جوجل للمتصفح",
          OrganizationBrowserGoogleKeyPlaceholder: "أدخل مفتاح جوجل للمتصفح",
          OrganizationTimezone: "المنطقة الزمنية",
          OrganizationTimezonePlaceholder: "اختر المنطقة الزمنية",
          OrganizationCurrency: "العملة",
          OrganizationCurrencyPlaceholder: "اختر العملة",
          Language: "اللغة",
          LanguagePlaceholder: "اختر اللغة",
          OrganizationDetails: "تفاصيل المنظمة",
          OrganizationAdminDetails: "تفاصيل مسؤول المنظمة",
          SubscriptionDetails: "تفاصيل الاشتراك",
          AppsandAPISettings: "إعدادات التطبيقات وواجهة البرمجة",
          UpdateOrganization: "تحديث المؤسسة",
          AddOrganization: "إضافة مؤسسة",
          Cancel: "إلغاء",
          ViewOrganization: "عرض المؤسسة",
          AccountType: "نوع الحساب",
          View: "عرض",
          Edit: "تعديل",
          Delete: "حذف",
          Block: "حظر",
          Unblock: "إلغاء الحظر",
          Entities: "الكيانات",
          Actions: "الإجراءات",
          Status: "الحالة",
          SearchAny: "ابحث عن أي شيء...",
          AreYouSureYouWantToBlock: "هل أنت متأكد أنك تريد الحظر؟",
          AreYouSureYouWantToUnblock: "هل أنت متأكد أنك تريد إلغاء الحظر؟",
          AreYouSureYouWantToDelete: "هل أنت متأكد أنك تريد الحذف؟",
          Confirm: "تأكيد",
          EditOrganization: "تعديل المؤسسة",
          organizationAdmin: "مسؤول المؤسسة",
          Holidays: "الأعياد",
          AddHolidays: "إضافة عطلة",
          HolidayNamePlaceholder: "اسم العطلة",
          HolidayName: "اسم العطلة",
          Type: "النوع",
          SelectType: "اختر النوع",
          Country: "الدولة",
          SelectCountry: "اختر الدولة",
          IsthisaTentativeDate: "هل هذا تاريخ مؤقت؟",
          "Sl.No": "الرقم",
          Date: "التاريخ",
          SearchTableButton: "بحث",
          AddHoliday: "إضافة عطلة",
          "Update Holiday": "تحديث العطلة",
          Active: "نشط",
          Inactive: "غير نشط",
          National: "وطني",
          Religious: "ديني",
          Cultural: "ثقافي",
          Public: "عام",
          Countries: "الدول",
          Years: "سنوات",
          Search: "يبحث",
          SearchByHolidayName: "البحث باسم العطلة",
          Arabic: "يحفظ",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Action: "Action",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
        },
      },
      du: {
        translations: {
          General: "Allgemein",
          Dashboards: "Dashboards",
          Default: "Standard",
          Project: "Projekt",
          Ecommerce: "E-Commerce",
          Education: "Bildung",
          Widgets: "Widgets",
          Chart: "Diagramm",
          Applications: "Anwendungen",
          "Project List": "Projektliste",
          "Create New": "Neu erstellen",
          "File Manager": "Dateimanager",
          "Add Product": "Produkt hinzufügen",
          Product: "Produkt",
          "Product Page": "Produktseite",
          "Product List": "Produktliste",
          "Payment Details": "Zahlungsdetails",
          "Order History": "Bestellverlauf",
          Invoice: "Rechnung",
          "Invoice-1": "Rechnung-1",
          "Invoice-2": "Rechnung-2",
          "Invoice-3": "Rechnung-3",
          "Invoice-4": "Rechnung-4",
          "Invoice-5": "Rechnung-5",
          "Invoice-6": "Rechnung-6",
          Cart: "Warenkorb",
          Wishlist: "Wunschliste",
          Checkout: "Kasse",
          Pricing: "Preisgestaltung",
          Chat: "Chat",
          Users: "Benutzer",
          "Letter Box": "Briefkasten",
          "Private Chat": "Privater Chat",
          "Group Chat": "Gruppenchat",
          "User Profile": "Benutzerprofil",
          "User Edit": "Benutzer bearbeiten",
          "User Cards": "Benutzerkarten",
          Bookmarks: "Lesezeichen",
          Contacts: "Kontakte",
          Task: "Aufgabe",
          Calendar: "Kalender",
          "Social App": "Soziale App",
          Todo: "To-Do",
          "Search Result": "Suchergebnis",
          "Form Validation": "Formularvalidierung",
          "Base Inputs": "Grundlegende Eingaben",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Eingabegruppen",
          "Input Mask": "Eingabemaske",
          "Mega Option": "Mega-Option",
          Datepicker: "Datumsauswahl",
          Touchspin: "Touchspin",
          Switch: "Schalter",
          Forms: "Formulare",
          "Form Controls": "Formularelemente",
          "Forms & Table": "Formulare & Tabelle",
          Typeahead: "Typsuche",
          Clipboard: "Zwischenablage",
          "Form Widget": "Formularelement",
          "Form Wizard 1": "Formular-Assistent 1",
          "Form Wizard 2": "Formular-Assistent 2",
          "Two Factor": "Zwei-Faktor",
          "Form Layout": "Formularlayout",
          Table: "Tabelle",
          "Reactstrap Tables": "Reactstrap-Tabellen",
          "Basic Tables": "Grundlegende Tabellen",
          "Table Components": "Tabellenkomponenten",
          "Data Tables": "Daten-Tabellen",
          "Basic Init": "Grundlegende Initialisierung",
          "Advance Init": "Erweiterte Initialisierung",
          API: "API",
          "Data Source": "Datenquelle",
          Components: "Komponenten",
          Typography: "Typografie",
          Avatars: "Avatare",
          "Helper Classes": "Hilfsklassen",
          Grid: "Raster",
          "Tag & Pills": "Schlagwörter & Pillen",
          Progress: "Fortschritt",
          Modal: "Modales Fenster",
          Alert: "Benachrichtigung",
          Popover: "Popover",
          Tooltip: "Tooltip",
          Dropdown: "Dropdown",
          Accordion: "Akkordeon",
          Tabs: "Tabs",
          Lists: "Listen",
          "Bonus-Ui": "Zusatz-UI",
          Scrollable: "Scrollbar",
          "Tree View": "Baumansicht",
          Toasts: "Benachrichtigungen",
          Rating: "Bewertung",
          Dropzone: "Dateiablage",
          Tour: "Tour",
          SweetAlert2: "SweetAlert2",
          Carousel: "Eulenkarussell",
          Ribbons: "Bänder",
          Pagination: "Seitennummerierung",
          Breadcrumb: "Brotkrumen",
          "Range Slider": "Bereichsschieberegler",
          "Image Cropper": "Bildzuschnitt",
          "Basic Card": "Grundlegende Karte",
          "Creative Card": "Kreative Karte",
          Timeline: "Zeitachse",
          Icons: "Symbole",
          "Flag Icon": "Flaggensymbol",
          "Fontawesome Icon": "Font Awesome Symbol",
          "Ico Icon": "Ico Symbol",
          "Themify Icon": "Themify Symbol",
          "Feather Icon": "Feather Symbol",
          "Weather Icon": "Wettersymbol",
          Buttons: "Schaltflächen",
          "Default Style": "Standardstil",
          "Flat Style": "Flacher Stil",
          "Edge Style": "Edge-Stil",
          "Raised Style": "Erhöhter Stil",
          "Button Group": "Schaltflächengruppe",
          Charts: "Diagramme",
          "Apex Chart": "Apex Diagramm",
          "Ui-Kits": "Benutzeroberflächen-Kits",
          "Google Chart": "Google Diagramm",
          "Chart JS Chart": "Chart JS Diagramm",
          Pages: "Seiten",
          "Sample Page": "Beispielseite",
          Others: "Andere",
          "Error Pages": "Fehlerseiten",
          "Error 400": "Fehler 400",
          "Error 401": "Fehler 401",
          "Error 403": "Fehler 403",
          "Error 404": "Fehler 404",
          "Error 500": "Fehler 500",
          "Error 503": "Fehler 503",
          "Login Simple": "Einfaches Anmelden",
          "Login with Bg Image": "Anmelden mit Hintergrundbild",
          "Login With Image Two": "Anmelden mit zwei Bildern",
          "Login With Validation": "Anmelden mit Validierung",
          "Login With Tooltip": "Anmelden mit Tooltip",
          "Login With Sweetalert": "Anmelden mit SweetAlert",
          "Register Simple": "Einfache Registrierung",
          "Register With Bg Image": "Registrieren mit Hintergrundbild",
          "Register With Bg Two": "Registrieren mit zwei Bildern",
          "Register Wizard": "Registrierungsassistent",
          "Unlock User": "Benutzer entsperren",
          "Forget Password": "Passwort vergessen",
          "Reset Password": "Passwort zurücksetzen",
          Maintenance: "Wartung",
          "Coming Simple": "Einfache Ankündigung",
          "Coming With Bg Video": "Ankündigung mit Hintergrundvideo",
          "Coming With Bg Image": "Ankündigung mit Hintergrundbild",
          Miscellaneous: "Sonstiges",
          Gallery: "Galerie",
          "Gallery Grids": "Galerie Raster",
          "Gallery Grid Desc": "Galerie Raster Beschreibung",
          "Masonry Gallery": "Mauerwerk-Galerie",
          "Masonry With Desc": "Mauerwerk mit Beschreibung",
          "Hover Effect": "Hover-Effekt",
          Blog: "Blog",
          "Blog Details": "Blogdetails",
          "Blog Single": "Einzelner Blog",
          "Add Post": "Beitrag hinzufügen",
          FAQ: "FAQ",
          "Job Search": "Job-Suche",
          "Cards View": "Kartenansicht",
          "List View": "Listenansicht",
          "Job Detail": "Jobdetails",
          Apply: "Bewerben",
          Learning: "Lernen",
          "Learning List": "Lernliste",
          "Detailed Course": "Detaillierter Kurs",
          Map: "Karte",
          "Google Map": "Google Karte",
          "Leaflet Map": "Leaflet Karte",
          Editor: "Editor",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          "ACE Editor": "ACE Editor",
          Knowledgebase: "Wissensdatenbank",
          "Support Ticket": "Ticket de support",
          Authentication: "Authentifizierung",
          "Login With Bg Image": "Anmeldung mit Hintergrundbild",
          Pinned: "Gepinnt",
          "Coming Soon": "Demnächst",
          "Master Data": "Stamgegevens",
          Organizations: "Organisaties",
          Dashboard: "Dashboard",
          OrganizationName: "Organisatienaam",
          OrganizationNamePlaceholder: "Organisatienaam *",
          OrganizationMobile: "Mobiel Nummer",
          OrganizationMobilePlaceholder: "Voer mobiel nummer in",
          OrganizationEmail: "E-mail",
          OrganizationEmailPlaceholder: "Voer e-mailadres in",
          OrganizationAddress: "Adres",
          OrganizationAddressPlaceholder: "Voer adres in",
          OrganizationCountry: "Land",
          OrganizationCountryPlaceholder: "Selecteer land",
          OrganizationCity: "Stad",
          OrganizationCityPlaceholder: "Selecteer stad",
          OrganizationIndustry: "Industrie",
          OrganizationIndustryPlaceholder: "Selecteer industrie",
          Authority: "Autoriteit",
          AuthorityPlaceholder: "Selecteer autoriteit",
          OrganizationLogo: "Organisatielogo",
          OrganizationWebsite: "Website van de organisatie",
          OrganizationWebsitePlaceholder: "Voer website van de organisatie in",
          WhiteLabel: "Wit Label",
          OrganizationContactPerson: "Contactpersoon",
          OrganizationContactPersonPlaceholder: "Voer contactpersoon in",
          OrganizationSubscriptionPlan: "Abonnementsplan",
          OrganizationSubscriptionPlanPlaceholder: "Selecteer abonnementsplan",
          ExpireyDate: "Vervaldatum",
          PageLimit: "Paginalimiet",
          PageLimitPlaceholder: "Selecteer paginalimiet",
          DateFormat: "Datumformaat",
          DateFormatPlaceholder: "Selecteer datumformaat",
          Distributor: "Distributeur",
          DistributorPlaceholder: "Selecteer distributeur",
          Franchises: "Franchises",
          FranchisesPlaceholder: "Selecteer franchises",
          EmployeeAppAndroidKey: "Android-sleutel van medewerkersapp",
          EmployeeAppAndroidkeyplaceholder: "Voer Android-sleutel in",
          EmployeeAppAndroidURL: "Android-URL van medewerkersapp",
          EmployeeAppAndroidURLplaceholder: "Voer Android-URL in",
          EmployeeAppIOSKey: "iOS-sleutel van medewerkersapp",
          EmployeeAppIOSkeyplaceholder: "Voer iOS-sleutel in",
          EmployeeAppIOSURL: "iOS-URL van medewerkersapp",
          EmployeeAppIOURLplaceholder: "Voer iOS-URL in",
          OrganizationBrowserGoogleKey: "Browser Google-sleutel",
          OrganizationBrowserGoogleKeyPlaceholder: "Voer Google-sleutel in",
          OrganizationTimezone: "Tijdzone",
          OrganizationTimezonePlaceholder: "Selecteer tijdzone",
          OrganizationCurrency: "Valuta",
          OrganizationCurrencyPlaceholder: "Selecteer valuta",
          Language: "Taal",
          LanguagePlaceholder: "Selecteer taal",
          OrganizationDetails: "Organisatiedetails",
          OrganizationAdminDetails: "Organisatiebeheerderdetails",
          SubscriptionDetails: "Abonnementsdetails",
          AppsandAPISettings: "Apps- en API-instellingen",
          UpdateOrganization: "Organisatie bijwerken",
          AddOrganization: "Organisatie toevoegen",
          Cancel: "Annuleren",
          ViewOrganization: "Bekijk organisatie",
          AccountType: "Accounttype",
          View: "Ver",
          Edit: "Editar",
          Delete: "Eliminar",
          Block: "Bloquear",
          Unblock: "Desbloquear",
          Entity: "Entiteit",
          Entities: "Entiteiten",
          Actions: "Acties",
          Status: "Status",
          SearchAny: "Zoek alles...",
          AreYouSureYouWantToBlock: "Weet je zeker dat je wilt blokkeren",
          AreYouSureYouWantToUnblock:
            "Weet je zeker dat je de blokkering wilt opheffen",
          AreYouSureYouWantToDelete: "Weet je zeker dat je wilt verwijderen",
          Confirm: "Bevestigen",
          EditOrganization: "Organisatie bewerken",
          organizationAdmin: "Beheerder van de organisatie",
          Holidays: "Feiertage",
          AddHolidays: "Feiertag hinzufügen",
          HolidayNamePlaceholder: "Name des Feiertags",
          HolidayName: "Name des Feiertags",
          Type: "Typ",
          SelectType: "Typ auswählen",
          Country: "Land",
          SelectCountry: "Land auswählen",
          IsthisaTentativeDate: "Ist dies ein vorläufiges Datum?",
          "Sl.No": "Nr.",
          Date: "Datum",
          SearchTableButton: "Suchen",
          AddHoliday: "Feiertag hinzufügen",
          "Update Holiday": "Feiertag aktualisieren",
          Active: "Aktiv",
          Inactive: "Inaktiv",
          National: "National",
          Religious: "Religiös",
          Cultural: "Kulturell",
          Public: "Öffentlich",
          Countries: "Länder",
          Years: "Jahre",
          Search: "Suchen",
          SearchByHolidayName: "Nach Feiertagsname suchen",
          Save: "Speichern",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Action: "Action",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
        },
      },
      es: {
        translations: {
          General: "General",
          Dashboards: "Paneles",
          Default: "Predeterminado",
          Project: "Proyecto",
          Ecommerce: "Comercio Electrónico",
          Education: "Educación",
          Widgets: "Widgets",
          Chart: "Gráfico",
          Applications: "Aplicaciones",
          "Project List": "Lista de Proyectos",
          "Create New": "Crear Nuevo",
          "File Manager": "Gestor de Archivos",
          "Add Product": "Agregar Producto",
          Product: "Producto",
          "Product Page": "Página de Producto",
          "Product List": "Lista de Productos",
          "Payment Details": "Detalles de Pago",
          "Order History": "Historial de Pedidos",
          Invoice: "Factura",
          "Invoice-1": "Factura-1",
          "Invoice-2": "Factura-2",
          "Invoice-3": "Factura-3",
          "Invoice-4": "Factura-4",
          "Invoice-5": "Factura-5",
          "Invoice-6": "Factura-6",
          Cart: "Carrito",
          Wishlist: "Lista de Deseos",
          Checkout: "Pagar",
          Pricing: "Precios",
          Chat: "Chat",
          Users: "Usuarios",
          "Letter Box": "Buzón de Correo",
          "Private Chat": "Chat Privado",
          "Group Chat": "Chat de Grupo",
          "User Profile": "Perfil de Usuario",
          "User Edit": "Editar Usuario",
          "User Cards": "Tarjetas de Usuario",
          Bookmarks: "Marcadores",
          Contacts: "Contactos",
          Task: "Tarea",
          Calendar: "Calendario",
          "Social App": "Aplicación Social",
          Todo: "Tareas Pendientes",
          "Search Result": "Resultado de Búsqueda",
          "Form Validation": "Validación de Formulario",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Casillas de Verificación y Radio",
          "Input Groups": "Grupos de Entrada",
          "Input Mask": "Máscara de Entrada",
          "Mega Option": "Opción Mega",
          Datepicker: "Selector de Fecha",
          Touchspin: "Selector Numérico",
          Switch: "Interruptor",
          Forms: "Formularios",
          "Form Controls": "Controles de Formulario",
          "Forms & Table": "Formularios y Tabla",
          Typeahead: "Búsqueda Predictiva",
          Clipboard: "Portapapeles",
          "Form Widget": "Widget de Formulario",
          "Form Wizard 1": "Asistente de Formulario 1",
          "Form Wizard 2": "Asistente de Formulario 2",
          "Two Factor": "Doble Factor",
          "Form Layout": "Diseño de Formulario",
          Table: "Tabla",
          "Reactstrap Tables": "Tablas Reactstrap",
          "Basic Tables": "Tablas Básicas",
          "Table Components": "Componentes de Tabla",
          "Data Tables": "Tablas de Datos",
          "Basic Init": "Inicio Básico",
          "Advance Init": "Inicio Avanzado",
          API: "API",
          "Data Source": "Fuente de Datos",
          Components: "Componentes",
          Typography: "Tipografía",
          Avatars: "Avatares",
          "Helper Classes": "Clases de Ayuda",
          Grid: "Cuadrícula",
          "Tag & Pills": "Etiquetas y Píldoras",
          Progress: "Progreso",
          Modal: "Modal",
          Alert: "Alerta",
          Popover: "Popover",
          Tooltip: "Información sobre Herramientas",
          Dropdown: "Menú Desplegable",
          Accordion: "Acordeón",
          Tabs: "Pestañas",
          Lists: "Listas",
          "Bonus-Ui": "UI Adicional",
          Scrollable: "Desplazable",
          "Tree View": "Vista de Árbol",
          Toasts: "Notificaciones",
          Rating: "Valoración",
          Dropzone: "Zona de Descarga",
          Tour: "Recorrido",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrusel",
          Ribbons: "Cintas",
          Pagination: "Paginación",
          Breadcrumb: "Migas de Pan",
          "Range Slider": "Control Deslizante de Rango",
          "Image Cropper": "Recortador de Imagen",
          "Basic Card": "Tarjeta Básica",
          "Creative Card": "Tarjeta Creativa",
          Timeline: "Línea de Tiempo",
          Icons: "Iconos",
          "Flag Icon": "Icono de Bandera",
          "Fontawesome Icon": "Icono Font Awesome",
          "Ico Icon": "Icono Ico",
          "Themify Icon": "Icono Themify",
          "Feather Icon": "Icono Feather",
          "Weather Icon": "Icono del Tiempo",
          Buttons: "Botones",
          "Default Style": "Estilo Predeterminado",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo Edge",
          "Raised Style": "Estilo Elevado",
          "Button Group": "Grupo de Botones",
          Charts: "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico de Google",
          "Chart JS Chart": "Gráfico de Chart JS",
          Pages: "Páginas",
          "Sample Page": "Página de Ejemplo",
          Others: "Otros",
          "Error Pages": "Páginas de Error",
          "Error 400": "Error 400",
          "Error 401": "Error 401",
          "Error 403": "Error 403",
          "Error 404": "Error 404",
          "Error 500": "Error 500",
          "Error 503": "Error 503",
          "Login Simple": "Inicio de Sesión Simple",
          "Login with Bg Image": "Inicio de Sesión con Imagen de Fondo",
          "Login With Image Two": "Inicio de Sesión con Dos Imágenes",
          "Login With Validation": "Inicio de Sesión con Validación",
          "Login With Tooltip": "Inicio de Sesión con Información Emergente",
          "Login With Sweetalert": "Inicio de Sesión con SweetAlert",
          "Register Simple": "Registro Simple",
          "Register With Bg Image": "Registro con Imagen de Fondo",
          "Register With Bg Two": "Registro con Dos Imágenes",
          "Register Wizard": "Asistente de Registro",
          "Unlock User": "Desbloquear Usuario",
          "Forget Password": "Olvidé mi Contraseña",
          "Reset Password": "Restablecer Contraseña",
          Maintenance: "Mantenimiento",
          "Coming Simple": "Próximamente Simple",
          "Coming With Bg Video": "Próximamente con Video de Fondo",
          "Coming With Bg Image": "Próximamente con Imagen de Fondo",
          Miscellaneous: "Misceláneo",
          Gallery: "Galería",
          "Gallery Grids": "Galería en Cuadrícula",
          "Gallery Grid Desc": "Descripción de la Galería en Cuadrícula",
          "Masonry Gallery": "Galería de Albañilería",
          "Masonry With Desc": "Albañilería con Descripción",
          "Hover Effect": "Efecto de Desplazamiento",
          Blog: "Blog",
          "Blog Details": "Detalles del Blog",
          "Blog Single": "Entrada de Blog Individual",
          "Add Post": "Agregar Entrada",
          FAQ: "Preguntas Frecuentes",
          "Job Search": "Búsqueda de Trabajo",
          "Cards View": "Vista de Tarjetas",
          "List View": "Vista de Lista",
          "Job Detail": "Detalle del Trabajo",
          Apply: "Solicitar",
          Learning: "Aprendizaje",
          "Learning List": "Lista de Aprendizaje",
          "Detailed Course": "Curso Detallado",
          Map: "Mapa",
          "Google Map": "Mapa de Google",
          "Leaflet Map": "Mapa de Leaflet",
          Editor: "Editor",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          "ACE Editor": "Editor ACE",
          Knowledgebase: "Base de Conocimientos",
          "Ui-Kits": "Kits de Interfaz de Usuario.",
          "Support Ticket": "Ticket de Soporte",
          Authentication: "Autenticación",
          "Login With Bg Image": "Inicio de sesión con imagen de fondo",
          Pinned: "Fijado",
          "Coming Soon": "Próximamente",
          "Master Data": "Datos maestros",
          Organizations: "Organizaciones",
          Dashboard: "Dashboard",
          OrganizationName: "Nombre de la organización",
          OrganizationNamePlaceholder: "Nombre de la organización *",
          OrganizationMobile: "Número de móvil",
          OrganizationMobilePlaceholder: "Ingrese número de móvil",
          OrganizationEmail: "Correo electrónico",
          OrganizationEmailPlaceholder:
            "Ingrese dirección de correo electrónico",
          OrganizationAddress: "Dirección",
          OrganizationAddressPlaceholder: "Ingrese dirección",
          OrganizationCountry: "País",
          OrganizationCountryPlaceholder: "Seleccione país",
          OrganizationCity: "Ciudad",
          OrganizationCityPlaceholder: "Seleccione ciudad",
          OrganizationIndustry: "Industria",
          OrganizationIndustryPlaceholder: "Seleccione industria",
          Authority: "Autoridad",
          AuthorityPlaceholder: "Seleccione autoridad",
          OrganizationLogo: "Logotipo de la organización",
          OrganizationWebsite: "Sitio web de la organización",
          OrganizationWebsitePlaceholder:
            "Ingrese sitio web de la organización",
          WhiteLabel: "Marca blanca",
          OrganizationContactPerson: "Persona de contacto",
          OrganizationContactPersonPlaceholder: "Ingrese persona de contacto",
          OrganizationSubscriptionPlan: "Plan de suscripción",
          OrganizationSubscriptionPlanPlaceholder:
            "Seleccione plan de suscripción",
          ExpireyDate: "Fecha de vencimiento",
          PageLimit: "Límite de páginas",
          PageLimitPlaceholder: "Seleccione límite de páginas",
          DateFormat: "Formato de fecha",
          DateFormatPlaceholder: "Seleccione formato de fecha",
          Distributor: "Distribuidor",
          DistributorPlaceholder: "Seleccione distribuidor",
          Franchises: "Franquicias",
          FranchisesPlaceholder: "Seleccione franquicias",
          EmployeeAppAndroidKey:
            "Clave de Android de la aplicación de empleados",
          EmployeeAppAndroidkeyplaceholder: "Ingrese clave de Android",
          EmployeeAppAndroidURL: "URL de Android de la aplicación de empleados",
          EmployeeAppAndroidURLplaceholder: "Ingrese URL de Android",
          EmployeeAppIOSKey: "Clave de iOS de la aplicación de empleados",
          EmployeeAppIOSkeyplaceholder: "Ingrese clave de iOS",
          EmployeeAppIOSURL: "URL de iOS de la aplicación de empleados",
          EmployeeAppIOURLplaceholder: "Ingrese URL de iOS",
          OrganizationBrowserGoogleKey: "Clave de Google del navegador",
          OrganizationBrowserGoogleKeyPlaceholder:
            "Ingrese clave de Google del navegador",
          OrganizationTimezone: "Zona horaria",
          OrganizationTimezonePlaceholder: "Seleccione zona horaria",
          OrganizationCurrency: "Moneda",
          OrganizationCurrencyPlaceholder: "Seleccione moneda",
          Language: "Idioma",
          LanguagePlaceholder: "Seleccione idioma",
          OrganizationDetails: "Detalles de la organización",
          OrganizationAdminDetails:
            "Detalles del administrador de la organización",
          SubscriptionDetails: "Detalles de suscripción",
          AppsandAPISettings: "Configuraciones de aplicaciones y API",
          UpdateOrganization: "Actualizar Organización",
          AddOrganization: "Agregar Organización",
          Cancel: "Cancelar",
          ViewOrganization: "Ver organización",
          AccountType: "Tipo de cuenta",
          View: "Ver",
          Edit: "Editar",
          Delete: "Eliminar",
          Block: "Bloquear",
          Unblock: "Desbloquear",
          Entity: "Entidad",
          Entities: "Entidades",
          Actions: "Acciones",
          Status: "Estado",
          SearchAny: "Buscar cualquier cosa...",
          AreYouSureYouWantToBlock: "Estás seguro de que deseas bloquear",
          AreYouSureYouWantToUnblock: "Estás seguro de que deseas desbloquear",
          AreYouSureYouWantToDelete: "Estás seguro de que deseas eliminar",
          Confirm: "Confirmar",
          EditOrganization: "Editar organización",
          organizationAdmin: "Administrador de la organización",
          Holidays: "Días Festivos",
          AddHolidays: "Agregar Día Festivo",
          HolidayNamePlaceholder: "Nombre del día festivo",
          HolidayName: "Nombre del Día Festivo",
          Type: "Tipo",
          SelectType: "Seleccionar Tipo",
          Country: "País",
          SelectCountry: "Seleccionar País",
          IsthisaTentativeDate: "Es una fecha tentativa",
          "Sl.No": "Nº",
          Date: "Fecha",
          SearchTableButton: "Buscar",
          AddHoliday: "Agregar Día Festivo",
          "Update Holiday": "Actualizar Día Festivo",
          Active: "Activo",
          Inactive: "Inactivo",
          National: "Nacional",
          Religious: "Religioso",
          Cultural: "Cultural",
          Public: "Público",
          Countries: "Países",
          Years: "Años",
          Search: "buscar",
          SearchByHolidayName: "Buscar por nombre del día festive",
          Save: "Ahorrar",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Action: "Action",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
        },
      },
      fr: {
        translations: {
          General: "Général",
          Dashboards: "Tableaux de bord",
          Default: "Défaut",
          Project: "Projet",
          Ecommerce: "Commerce électronique",
          Education: "Éducation",
          Widgets: "Widgets",
          Chart: "Graphique",
          Applications: "Applications",
          "Project List": "Liste de projets",
          "Create New": "Créer un nouveau",
          "File Manager": "Gestionnaire de fichiers",
          "Add Product": "Ajouter un produit",
          Product: "Produit",
          "Product Page": "Page de produit",
          "Product List": "Liste de produits",
          "Payment Details": "Détails de paiement",
          "Order History": "Historique des commandes",
          Invoice: "Facture",
          "Invoice-1": "Facture-1",
          "Invoice-2": "Facture-2",
          "Invoice-3": "Facture-3",
          "Invoice-4": "Facture-4",
          "Invoice-5": "Facture-5",
          "Invoice-6": "Facture-6",
          Cart: "Panier",
          Wishlist: "Liste de souhaits",
          Checkout: "Paiement",
          Pricing: "Tarification",
          Chat: "Discussion",
          Users: "Utilisateurs",
          "Letter Box": "Boîte aux lettres",
          "Private Chat": "Discussion privée",
          "Group Chat": "Discussion de groupe",
          "User Profile": "Profil de l'utilisateur",
          "User Edit": "Modifier l'utilisateur",
          "User Cards": "Cartes d'utilisateur",
          Bookmarks: "Signets",
          Contacts: "Contacts",
          Task: "Tâche",
          Calendar: "Calendrier",
          "Social App": "Application sociale",
          Todo: "À faire",
          "Search Result": "Résultat de la recherche",
          "Form Validation": "Validation de formulaire",
          "Base Inputs": "Entrées de base",
          "Checkbox & Radio": "Cases à cocher et boutons radio",
          "Input Groups": "Groupes d'entrée",
          "Input Mask": "Masque de saisie",
          "Mega Option": "Option méga",
          Datepicker: "Sélecteur de date",
          Touchspin: "Touchspin",
          Switch: "Interrupteur",
          Forms: "Formulaires",
          "Form Controls": "Contrôles de formulaire",
          "Forms & Table": "Formulaires et table",
          Typeahead: "Suggestion de texte",
          Clipboard: "Presse-papiers",
          "Form Widget": "Widget de formulaire",
          "Form Wizard 1": "Assistant de formulaire 1",
          "Form Wizard 2": "Assistant de formulaire 2",
          "Two Factor": "Double authentification",
          "Form Layout": "Mise en page du formulaire",
          Table: "Tableau",
          "Reactstrap Tables": "Tableaux Reactstrap",
          "Basic Tables": "Tables de base",
          "Table Components": "Composants de tableau",
          "Data Tables": "Tableaux de données",
          "Basic Init": "Initialisation de base",
          "Advance Init": "Initialisation avancée",
          API: "API",
          "Data Source": "Source de données",
          Components: "Composants",
          Typography: "Typographie",
          Avatars: "Avatars",
          "Helper Classes": "Classes d'aide",
          Grid: "Grille",
          "Tag & Pills": "Étiquettes et pastilles",
          Progress: "Progression",
          Modal: "Fenêtre modale",
          Alert: "Alerte",
          Popover: "Infobulle",
          Tooltip: "Info-bulle",
          Dropdown: "Menu déroulant",
          Accordion: "Accordéon",
          Tabs: "Onglets",
          Lists: "Listes",
          "Bonus-Ui": "Bonus-UI",
          Scrollable: "Déroulant",
          "Tree View": "Vue arborescente",
          Toasts: "Notifications",
          Rating: "Évaluation",
          Dropzone: "Zone de dépôt",
          Tour: "Visite guidée",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrousel",
          Ribbons: "Rubans",
          Pagination: "Pagination",
          Breadcrumb: "Fil d'Ariane",
          "Range Slider": "Curseur de plage",
          "Image Cropper": "Recadrage d'image",
          "Basic Card": "Carte de base",
          "Creative Card": "Carte créative",
          Timeline: "Chronologie",
          Icons: "Icônes",
          "Flag Icon": "Icône de drapeau",
          "Fontawesome Icon": "Icône Fontawesome",
          "Ico Icon": "Icône Ico",
          "Themify Icon": "Icône Themify",
          "Feather Icon": "Icône Feather",
          "Weather Icon": "Icône météo",
          Buttons: "Boutons",
          "Default Style": "Style par défaut",
          "Flat Style": "Style plat",
          "Edge Style": "Style en relief",
          "Raised Style": "Style en relief",
          "Button Group": "Groupe de boutons",
          Charts: "Graphiques",
          "Apex Chart": "Graphique Apex",
          "Google Chart": "Graphique Google",
          "Chart JS Chart": "Graphique Chart JS",
          Pages: "Pages",
          "Sample Page": "Page d'exemple",
          Others: "Autres",
          "Error Pages": "Pages d'erreur",
          "Error 400": "Erreur 400",
          "Error 401": "Erreur 401",
          "Error 403": "Erreur 403",
          "Error 404": "Erreur 404",
          "Error 500": "Erreur 500",
          "Error 503": "Erreur 503",
          "Login Simple": "Connexion simple",
          "Login with Bg Image": "Connexion avec image de fond",
          "Login With Image Two": "Connexion avec deux images",
          "Login With Validation": "Connexion avec validation",
          "Login With Tooltip": "Connexion avec info-bulle",
          "Login With Sweetalert": "Connexion avec SweetAlert",
          "Register Simple": "Inscription simple",
          "Register With Bg Image": "Inscription avec image de fond",
          "Register With Bg Two": "Inscription avec deux images de fond",
          "Register Wizard": "Assistant d'inscription",
          "Unlock User": "Déverrouiller l'utilisateur",
          "Forget Password": "Mot de passe oublié",
          "Reset Password": "Réinitialiser le mot de passe",
          Maintenance: "Maintenance",
          "Coming Simple": "Bientôt disponible (version simple)",
          "Coming With Bg Video": "Bientôt disponible avec vidéo de fond",
          "Coming With Bg Image": "Bientôt disponible avec image de fond",
          Miscellaneous: "Divers",
          Gallery: "Galerie",
          "Gallery Grids": "Grilles de galerie",
          "Gallery Grid Desc": "Description de la grille de galerie",
          "Masonry Gallery": "Galerie en maçonnerie",
          "Masonry With Desc": "Maçonnerie avec description",
          "Hover Effect": "Effet de survol",
          Blog: "Blog",
          "Blog Details": "Détails du blog",
          "Blog Single": "Article de blog unique",
          "Add Post": "Ajouter un article",
          FAQ: "FAQ",
          "Job Search": "Recherche d'emploi",
          "Cards View": "Vue en cartes",
          "List View": "Vue en liste",
          "Job Detail": "Détails de l'emploi",
          Apply: "Postuler",
          Learning: "Apprentissage",
          "Learning List": "Liste d'apprentissage",
          "Detailed Course": "Cours détaillé",
          Map: "Carte",
          "Google Map": "Carte Google",
          "Leaflet Map": "Carte Leaflet",
          Editor: "Éditeur",
          "CK Editor": "Éditeur CK",
          "MDE Editor": "Éditeur MDE",
          "ACE Editor": "Éditeur ACE",
          Knowledgebase: "Base de connaissances",
          "Ui-Kits": "Kits d'interface utilisateur.",
          "Support Ticket": "Ticket de support",
          Authentication: "Authentification",
          "Login With Bg Image": "Connexion avec Image de Fond",
          Pinned: "Épinglé",
          "Coming Soon": "Prochainement",
          "Master Data": "Données de base",
          Organizations: "Organisations",
          Dashboard: "Dashboard",
          OrganizationName: "Nom de l'organisation",
          OrganizationNamePlaceholder: "Nom de l'organisation *",
          OrganizationMobile: "Numéro de mobile",
          OrganizationMobilePlaceholder: "Entrez le numéro de mobile",
          OrganizationEmail: "Email",
          OrganizationEmailPlaceholder: "Entrez l'adresse email",
          OrganizationAddress: "Adresse",
          OrganizationAddressPlaceholder: "Entrez l'adresse",
          OrganizationCountry: "Pays",
          OrganizationCountryPlaceholder: "Sélectionnez un pays",
          OrganizationCity: "Ville",
          OrganizationCityPlaceholder: "Sélectionnez une ville",
          OrganizationIndustry: "Secteur d'activité",
          OrganizationIndustryPlaceholder: "Sélectionnez un secteur",
          Authority: "Autorité",
          AuthorityPlaceholder: "Sélectionnez une autorité",
          OrganizationLogo: "Logo de l'organisation",
          OrganizationWebsite: "Site web de l'organisation",
          OrganizationWebsitePlaceholder:
            "Entrez le site web de l'organisation",
          WhiteLabel: "Marque blanche",
          OrganizationContactPerson: "Personne de contact",
          OrganizationContactPersonPlaceholder:
            "Entrez une personne de contact",
          OrganizationSubscriptionPlan: "Plan d'abonnement",
          OrganizationSubscriptionPlanPlaceholder:
            "Sélectionnez un plan d'abonnement",
          ExpireyDate: "Date d'expiration",
          PageLimit: "Limite de pages",
          PageLimitPlaceholder: "Sélectionnez une limite de pages",
          DateFormat: "Format de date",
          DateFormatPlaceholder: "Sélectionnez un format de date",
          Distributor: "Distributeur",
          DistributorPlaceholder: "Sélectionnez un distributeur",
          Franchises: "Franchises",
          FranchisesPlaceholder: "Sélectionnez des franchises",
          EmployeeAppAndroidKey: "Clé Android de l'application employé",
          EmployeeAppAndroidkeyplaceholder: "Entrez la clé Android",
          EmployeeAppAndroidURL: "URL Android de l'application employé",
          EmployeeAppAndroidURLplaceholder: "Entrez l'URL Android",
          EmployeeAppIOSKey: "Clé iOS de l'application employé",
          EmployeeAppIOSkeyplaceholder: "Entrez la clé iOS",
          EmployeeAppIOSURL: "URL iOS de l'application employé",
          EmployeeAppIOURLplaceholder: "Entrez l'URL iOS",
          OrganizationBrowserGoogleKey: "Clé Google du navigateur",
          OrganizationBrowserGoogleKeyPlaceholder:
            "Entrez la clé Google du navigateur",
          OrganizationTimezone: "Fuseau horaire",
          OrganizationTimezonePlaceholder: "Sélectionnez un fuseau horaire",
          OrganizationCurrency: "Devise",
          OrganizationCurrencyPlaceholder: "Sélectionnez une devise",
          Language: "Langue",
          LanguagePlaceholder: "Sélectionnez une langue",
          OrganizationDetails: "Détails de l'organisation",
          OrganizationAdminDetails: "Détails de l'administrateur",
          SubscriptionDetails: "Détails de l'abonnement",
          AppsandAPISettings: "Paramètres des applications et de l'API",
          UpdateOrganization: "Mettre à jour l'organisation",
          AddOrganization: "Ajouter une organisation",
          Cancel: "Annuler",
          ViewOrganization: "Voir l'organisation",
          AccountType: "Type de compte",
          View: "Voir",
          Edit: "Modifier",
          Delete: "Supprimer",
          Block: "Bloquer",
          Unblock: "Débloquer",
          Entity: "Entité",
          Entities: "Entités",
          Actions: "Actions",
          Status: "Statut",
          SearchAny: "Rechercher n'importe quoi...",
          AreYouSureYouWantToBlock: "Êtes-vous sûr de vouloir bloquer ",
          AreYouSureYouWantToUnblock: "Êtes-vous sûr de vouloir débloquer ",
          AreYouSureYouWantToDelete: "Êtes-vous sûr de vouloir supprimer ",
          Confirm: "Confirmer",
          EditOrganization: "Modifier l'organisation",
          organizationAdmin: "Administrateur de l'organisation",
          Holidays: "Jours Fériés",
          AddHolidays: "Ajouter un Jour Férié",
          HolidayNamePlaceholder: "Nom du jour férié",
          HolidayName: "Nom du Jour Férié",
          Type: "Type",
          SelectType: "Sélectionner le Type",
          Country: "Pays",
          SelectCountry: "Sélectionner le Pays",
          IsthisaTentativeDate: "Est-ce une date provisoire",
          "Sl.No": "N°",
          Date: "Date",
          SearchTableButton: "Rechercher",
          AddHoliday: "Ajouter un Jour Férié",
          "Update Holiday": "Mettre à jour le Jour Férié",
          Active: "Actif",
          Inactive: "Inactif",
          National: "National",
          Religious: "Religieux",
          Cultural: "Culturel",
          Public: "Public",
          Countries: "Pays",
          Years: "Années",
          Search: "recherche",
          SearchByHolidayName: "Rechercher par nom du jour férié",
          Save: "Sauvegarder",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Action: "Action",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
        },
      },
      pt: {
        translations: {
          General: "Geral",
          Dashboards: "Painéis",
          Default: "Padrão",
          Project: "Projeto",
          Ecommerce: "Comércio Eletrônico",
          Education: "Educação",
          Widgets: "Widgets",
          Chart: "Gráfico",
          Applications: "Aplicativos",
          "Project List": "Lista de Projetos",
          "Create New": "Criar Novo",
          "File Manager": "Gerenciador de Arquivos",
          "Add Product": "Adicionar Produto",
          Product: "Produto",
          "Product Page": "Página do Produto",
          "Product List": "Lista de Produtos",
          "Payment Details": "Detalhes do Pagamento",
          "Order History": "Histórico de Pedidos",
          Invoice: "Fatura",
          "Invoice-1": "Fatura-1",
          "Invoice-2": "Fatura-2",
          "Invoice-3": "Fatura-3",
          "Invoice-4": "Fatura-4",
          "Invoice-5": "Fatura-5",
          "Invoice-6": "Fatura-6",
          Cart: "Carrinho",
          Wishlist: "Lista de Desejos",
          Checkout: "Finalizar Compra",
          Pricing: "Preços",
          Chat: "Chat",
          Users: "Usuários",
          "Letter Box": "Caixa de Correio",
          "Private Chat": "Chat Privado",
          "Group Chat": "Chat em Grupo",
          "User Profile": "Perfil do Usuário",
          "User Edit": "Editar Usuário",
          "User Cards": "Cartões de Usuário",
          Bookmarks: "Marcadores",
          Contacts: "Contatos",
          Task: "Tarefa",
          Calendar: "Calendário",
          "Social App": "Aplicativo Social",
          Todo: "Lista de Tarefas",
          "Search Result": "Resultado da Pesquisa",
          "Form Validation": "Validação de Formulário",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Caixas de Seleção e Rádio",
          "Input Groups": "Grupos de Entrada",
          "Input Mask": "Máscara de Entrada",
          "Mega Option": "Opção Mega",
          Datepicker: "Seletor de Data",
          Touchspin: "Touchspin",
          Switch: "Interruptor",
          Forms: "Formulários",
          "Form Controls": "Controles de Formulário",
          "Forms & Table": "Formulários e Tabela",
          Typeahead: "Sugestão de Texto",
          Clipboard: "Área de Transferência",
          "Form Widget": "Widget de Formulário",
          "Form Wizard 1": "Assistente de Formulário 1",
          "Form Wizard 2": "Assistente de Formulário 2",
          "Two Factor": "Autenticação em Dois Passos",
          "Form Layout": "Layout do Formulário",
          Table: "Tabela",
          "Reactstrap Tables": "Tabelas Reactstrap",
          "Basic Tables": "Tabelas Básicas",
          "Table Components": "Componentes de Tabela",
          "Data Tables": "Tabelas de Dados",
          "Basic Init": "Inicialização Básica",
          "Advance Init": "Inicialização Avançada",
          API: "API",
          "Data Source": "Fonte de Dados",
          Components: "Componentes",
          Typography: "Tipografia",
          Avatars: "Avatares",
          "Helper Classes": "Classes de Ajuda",
          Grid: "Grade",
          "Tag & Pills": "Etiqueta e Abas",
          Progress: "Progresso",
          Modal: "Modal",
          Alert: "Alerta",
          Popover: "Popover",
          Tooltip: "Dica de Ferramenta",
          Dropdown: "Menu Suspenso",
          Accordion: "Acordeão",
          Tabs: "Abas",
          Lists: "Listas",
          "Bonus-Ui": "UI Extra",
          Scrollable: "Rolável",
          "Tree View": "Visualização de Árvore",
          Toasts: "Notificações",
          Rating: "Avaliação",
          Dropzone: "Zona de Soltar",
          Tour: "Tour",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrossel",
          Ribbons: "Fitas",
          Pagination: "Paginação",
          Breadcrumb: "Migalha de Pão",
          "Range Slider": "Controle de Faixa",
          "Image Cropper": "Cortador de Imagem",
          "Basic Card": "Cartão Básico",
          "Creative Card": "Cartão Criativo",
          Timeline: "Linha do Tempo",
          Icons: "Ícones",
          "Flag Icon": "Ícone de Bandeira",
          "Fontawesome Icon": "Ícone Fontawesome",
          "Ico Icon": "Ícone Ico",
          "Themify Icon": "Ícone Themify",
          "Feather Icon": "Ícone Feather",
          "Weather Icon": "Ícone de Clima",
          Buttons: "Botões",
          "Default Style": "Estilo Padrão",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo em Destaque",
          "Raised Style": "Estilo em Relevo",
          "Button Group": "Grupo de Botões",
          Charts: "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico do Google",
          "Chart JS Chart": "Gráfico Chart JS",
          Pages: "Páginas",
          "Sample Page": "Página de Exemplo",
          Others: "Outros",
          "Error Pages": "Páginas de Erro",
          "Error 400": "Erro 400",
          "Error 401": "Erro 401",
          "Error 403": "Erro 403",
          "Error 404": "Erro 404",
          "Error 500": "Erro 500",
          "Error 503": "Erro 503",
          "Login Simple": "Login Simples",
          "Login with Bg Image": "Login com Imagem de Fundo",
          "Login With Image Two": "Login com Duas Imagens",
          "Login With Validation": "Login com Validação",
          "Login With Tooltip": "Login com Dica de Ferramenta",
          "Login With Sweetalert": "Login com SweetAlert",
          "Register Simple": "Registro Simples",
          "Register With Bg Image": "Registro com Imagem de Fundo",
          "Register With Bg Two": "Registro com Duas Imagens de Fundo",
          "Register Wizard": "Assistente de Registro",
          "Unlock User": "Desbloquear Usuário",
          "Forget Password": "Esqueci a Senha",
          "Reset Password": "Redefinir Senha",
          Maintenance: "Manutenção",
          "Coming Simple": "Em Breve - Simples",
          "Coming With Bg Video": "Em Breve com Vídeo de Fundo",
          "Coming With Bg Image": "Em Breve com Imagem de Fundo",
          Miscellaneous: "Diversos",
          Gallery: "Galeria",
          "Gallery Grids": "Grade de Galeria",
          "Gallery Grid Desc": "Descrição da Grade de Galeria",
          "Masonry Gallery": "Galeria em Alvenaria",
          "Masonry With Desc": "Alvenaria com Descrição",
          "Hover Effect": "Efeito de Passagem",
          Blog: "Blog",
          "Blog Details": "Detalhes do Blog",
          "Blog Single": "Postagem de Blog Única",
          "Add Post": "Adicionar Postagem",
          FAQ: "Perguntas Frequentes",
          "Job Search": "Busca de Empregos",
          "Cards View": "Visualização em Cartões",
          "List View": "Visualização em Lista",
          "Job Detail": "Detalhe do Emprego",
          Apply: "Aplicar",
          Learning: "Aprendizado",
          "Learning List": "Lista de Aprendizado",
          "Detailed Course": "Curso Detalhado",
          Map: "Mapa",
          "Google Map": "Mapa do Google",
          "Leaflet Map": "Mapa Leaflet",
          Editor: "Editor",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          "ACE Editor": "Editor ACE",
          Knowledgebase: "Base de Conhecimento",
          "Ui-Kits": "Kits de Interface de Usuário.",
          "Support Ticket": "Ticket de Suporte",
          Authentication: "Autenticação",
          "Login With Bg Image": "Login com Imagem de Fundo",
          Pinned: "Fixado",
          "Coming Soon": "Em Breve",
          "Master Data": "Dados mestres",
          Organizations: "Organizações",
          Dashboard: "Dashboard",
          OrganizationName: "Nome da Organização",
          OrganizationNamePlaceholder: "Nome da organização *",
          OrganizationMobile: "Número de Telefone",
          OrganizationMobilePlaceholder: "Insira o número de telefone",
          OrganizationEmail: "Email",
          OrganizationEmailPlaceholder: "Insira o endereço de email",
          OrganizationAddress: "Endereço",
          OrganizationAddressPlaceholder: "Insira o endereço",
          OrganizationCountry: "País",
          OrganizationCountryPlaceholder: "Selecione o país",
          OrganizationCity: "Cidade",
          OrganizationCityPlaceholder: "Selecione a cidade",
          OrganizationIndustry: "Indústria",
          OrganizationIndustryPlaceholder: "Selecione a indústria",
          Authority: "Autoridade",
          AuthorityPlaceholder: "Selecione a autoridade",
          OrganizationLogo: "Logotipo da Organização",
          OrganizationWebsite: "Website da Organização",
          OrganizationWebsitePlaceholder: "Insira o website da organização",
          WhiteLabel: "Marca Branca",
          OrganizationContactPerson: "Pessoa de Contato",
          OrganizationContactPersonPlaceholder: "Insira a pessoa de contato",
          OrganizationSubscriptionPlan: "Plano de Assinatura",
          OrganizationSubscriptionPlanPlaceholder:
            "Selecione o plano de assinatura",
          ExpireyDate: "Data de Expiração",
          PageLimit: "Limite de Páginas",
          PageLimitPlaceholder: "Selecione o limite de páginas",
          DateFormat: "Formato de Data",
          DateFormatPlaceholder: "Selecione o formato de data",
          Distributor: "Distribuidor",
          DistributorPlaceholder: "Selecione o distribuidor",
          Franchises: "Franquias",
          FranchisesPlaceholder: "Selecione as franquias",
          EmployeeAppAndroidKey: "Chave Android do Aplicativo do Funcionário",
          EmployeeAppAndroidkeyplaceholder: "Insira a chave Android",
          EmployeeAppAndroidURL: "URL Android do Aplicativo do Funcionário",
          EmployeeAppAndroidURLplaceholder: "Insira a URL Android",
          EmployeeAppIOSKey: "Chave iOS do Aplicativo do Funcionário",
          EmployeeAppIOSkeyplaceholder: "Insira a chave iOS",
          EmployeeAppIOSURL: "URL iOS do Aplicativo do Funcionário",
          EmployeeAppIOURLplaceholder: "Insira a URL iOS",
          OrganizationBrowserGoogleKey: "Chave Google do Navegador",
          OrganizationBrowserGoogleKeyPlaceholder:
            "Insira a chave Google do navegador",
          OrganizationTimezone: "Fuso Horário",
          OrganizationTimezonePlaceholder: "Selecione o fuso horário",
          OrganizationCurrency: "Moeda",
          OrganizationCurrencyPlaceholder: "Selecione a moeda",
          Language: "Idioma",
          LanguagePlaceholder: "Selecione o idioma",
          OrganizationDetails: "Detalhes da Organização",
          OrganizationAdminDetails: "Detalhes do Administrador da Organização",
          SubscriptionDetails: "Detalhes da Assinatura",
          AppsandAPISettings: "Configurações de Apps e API",
          UpdateOrganization: "Atualizar Organização",
          AddOrganization: "Adicionar Organização",
          Cancel: "Cancelar",
          ViewOrganization: "Ver Organização",
          AccountType: "Tipo de Conta",
          View: "Visualizar",
          Edit: "Editar",
          Delete: "Excluir",
          Block: "Bloquear",
          Unblock: "Desbloquear",
          Entity: "Entidade",
          Entities: "Entidades",
          Actions: "Ações",
          Status: "Status",
          SearchAny: "Pesquisar qualquer coisa...",
          AreYouSureYouWantToBlock: "Tem certeza de que deseja bloquear",
          AreYouSureYouWantToUnblock: "Tem certeza de que deseja desbloquear",
          AreYouSureYouWantToDelete: "Tem certeza de que deseja excluir",
          Confirm: "Confirmar",
          EditOrganization: "Editar organização",
          organizationAdmin: "Administrador da organização",
          Holidays: "Feriados",
          AddHolidays: "Adicionar Feriado",
          HolidayNamePlaceholder: "Nome do feriado",
          HolidayName: "Nome do Feriado",
          Type: "Tipo",
          SelectType: "Selecionar Tipo",
          Country: "País",
          SelectCountry: "Selecionar País",
          IsthisaTentativeDate: "É uma data provisória",
          "Sl.No": "Nº",
          Date: "Data",
          SearchTableButton: "Pesquisar",
          AddHoliday: "Adicionar Feriado",
          "Update Holiday": "Atualizar Feriado",
          Active: "Ativo",
          Inactive: "Inativo",
          National: "Nacional",
          Religious: "Religioso",
          Cultural: "Cultural",
          Public: "Público",
          Countries: "Países",
          Years: "Anos",
          Search: "procurar",
          SearchByHolidayName: "Pesquisar por nome do feriado",
          Save: "Guardar",
          Settings: "Settings",
          ImportHolidays: "Import Holidays",
          ImportHolidayInstructions: "Import Holiday Instructions",
          UseStandardExcelFormat: "Use Standard Excel Format",
          RequiredHolidayColumns:
            "Ensure the file contains required columns: {{columns}}",
          MaxFileSize: "Maximum file size is {{size}}.",
          SelectExcelFile: "Select Excel File",
          DownloadTemplate: "Download Template",
          Import: "Import",
          DateFormatImport: "Use date format: {{format}}",
          Reports: "Reports",
          UserActivity: "User Activity",
          IPManagement: "IP Management",
          WhiteList: "White List",
          BlackList: "Black List",
          nonList: "non - List",
          IPAddress: "IP Address",
          LastActivity: "Last Activity",
          DateTime: "Date & Time",
          Location: "Location",
          SearchIPAddress: "Search IP Address...",
          NoIPDataFound: "No IP data found.",
          GeneralSettings: "General Settings",
          MasterSetings: "Master Setings",
          TaxTypes: "Tax Types",
          AddTaxTypes: "Add Tax Types",
          LastLoginReport: "Last Login Report",
          userName: "User Name",
          userRole: "User Role",
          LoginFailures: "Login Failures",
          UsersReport: "Users Report",
          Reason: "Reason",
          Hits: "Hits",
          ViewAll: "View All",
          ErrorLog: "Error Log",
          firstOccuranceTime: "First Occurance Time",
          secondOccuranceTime: "Last Occurance Time",
          url: "URL",
          ErrorView: "Error-log View",
          MyProfile: "My Profile",
          ImportHolidayTypeInstructions: "Import Holiday Type Instructions",
          HolidayType: "Holiday Type",
          AddHolidayType: "Add Holiday Type",
          EditHolidayType: "Edit Holiday Type",
          TypeName: "Type Name",
          TypeNameRequired: "Type Name is required",
          Description: "Description",
          Add: "Add",
          Update: "Update",
          DeleteConfirmation: "Are you sure you want to delete?",
          Action: "Action",
          ImportHolidayType: "Import Holiday Type",
          HolidayTypeInstructions: "Holiday Type Instructions",
          LeaveType: "Leave Type",
        },
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
